/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export type WeightClassEnum =
  | "43"
  | "47"
  | "52"
  | "57"
  | "63"
  | "69"
  | "76"
  | "84"
  | "84+"
  | "53"
  | "59"
  | "66"
  | "74"
  | "83"
  | "93"
  | "105"
  | "120"
  | "120+"
  | "41"
  | "45"
  | "50"
  | "55"
  | "61"
  | "67"
  | "73"
  | "79"
  | "86"
  | "86+"
  | "49"
  | "54"
  | "65"
  | "72"
  | "80"
  | "88"
  | "97"
  | "107"
  | "107+";

/**
 * * `IPFGL` - IPFGL
 * * `IPFGL_MALE` - IPFGL Herr
 * * `IPF` - IPF
 * * `IPF_MALE` - IPF Herr
 * * `WILKS` - WILKS
 * * `WILKS_MALE` - WILKS Herr
 * * `DOTS` - DOTS
 * * `DOTS_MALE` - DOTS Herr
 */
export type ScoringSystemEnum =
  | "IPFGL"
  | "IPFGL_MALE"
  | "IPF"
  | "IPF_MALE"
  | "WILKS"
  | "WILKS_MALE"
  | "DOTS"
  | "DOTS_MALE";

/**
 * * `HD` - Huvuddomare
 * * `SD` - Sidodomare
 * * `TK` - Teknisk Kontrollant
 * * `TL` - Tävlingsledare
 * * `JU` - Jury
 * * `SP` - Speaker
 * * `IN` - Instruktör
 */
export type RoleEnum = "HD" | "SD" | "TK" | "TL" | "JU" | "SP" | "IN";

/**
 * * `APPROVED` - Approved
 * * `WITHDRAWN` - Withdrawn
 * * `NOT_APPROVED` - Not Approved
 */
export type RegistrationStateEnum = "APPROVED" | "WITHDRAWN" | "NOT_APPROVED";

/**
 * * `default` - Default
 * * `exclude` - Exclude
 * * `include` - Include
 */
export type RecordStatusEnum = "default" | "exclude" | "include";

/**
 * * `D` - Distriktsdomare
 * * `F` - Förbundsdomare
 * * `K2` - Kat 2. Domare
 * * `K1` - Kat 1. Domare
 */
export type RecentLevelParaEnum = "D" | "F" | "K2" | "K1";

export type PLRegistrationTypeEnum = "powerlifting" | "bench_press" | "para";

export type PLRegistrationSexEnum = "male" | "female";

export type PLAgeCategoriesEnum =
  | "U1"
  | "U2"
  | "JR"
  | "S"
  | "M1"
  | "M2"
  | "M3"
  | "M4"
  | "SM"
  | "UK"
  | "JK"
  | "SK"
  | "K1"
  | "K2"
  | "K3"
  | "K4"
  | "U"
  | "J"
  | "O"
  | "V"
  | "IFN-U1"
  | "IFN-U2"
  | "IFN-JR"
  | "IFN-S"
  | "IFN-M1"
  | "IFN-M2"
  | "IFN-M3"
  | "IFN-M4"
  | "IFN-M"
  | "IFN-SM"
  | "IFN-UK"
  | "IFN-JK"
  | "IFN-SK"
  | "IFN-K1"
  | "IFN-K2"
  | "IFN-K3"
  | "IFN-K4"
  | "IFN-KM";

export type NullEnum = null;

/**
 * * `powerlifting` - powerlifting
 * * `bench_press` - bench_press
 * * `para` - para
 */
export type LifterTypeEnum = "powerlifting" | "bench_press" | "para";

/**
 * * `male` - male
 * * `female` - female
 */
export type LifterSexEnum = "male" | "female";

/**
 * * `U1` - U1
 * * `U2` - U2
 * * `JR` - JR
 * * `S` - S
 * * `M1` - M1
 * * `M2` - M2
 * * `M3` - M3
 * * `M4` - M4
 * * `SM` - SM
 * * `UK` - UK
 * * `JK` - JK
 * * `SK` - SK
 * * `K1` - K1
 * * `K2` - K2
 * * `K3` - K3
 * * `K4` - K4
 * * `U` - U
 * * `J` - J
 * * `O` - O
 * * `V` - V
 * * `IFN-U1` - IFN-U1
 * * `IFN-U2` - IFN-U2
 * * `IFN-JR` - IFN-JR
 * * `IFN-S` - IFN-S
 * * `IFN-M1` - IFN-M1
 * * `IFN-M2` - IFN-M2
 * * `IFN-M3` - IFN-M3
 * * `IFN-M4` - IFN-M4
 * * `IFN-M` - IFN-M
 * * `IFN-SM` - IFN-SM
 * * `IFN-UK` - IFN-UK
 * * `IFN-JK` - IFN-JK
 * * `IFN-SK` - IFN-SK
 * * `IFN-K1` - IFN-K1
 * * `IFN-K2` - IFN-K2
 * * `IFN-K3` - IFN-K3
 * * `IFN-K4` - IFN-K4
 * * `IFN-KM` - IFN-KM
 */
export type LifterCategoryEnum =
  | "U1"
  | "U2"
  | "JR"
  | "S"
  | "M1"
  | "M2"
  | "M3"
  | "M4"
  | "SM"
  | "UK"
  | "JK"
  | "SK"
  | "K1"
  | "K2"
  | "K3"
  | "K4"
  | "U"
  | "J"
  | "O"
  | "V"
  | "IFN-U1"
  | "IFN-U2"
  | "IFN-JR"
  | "IFN-S"
  | "IFN-M1"
  | "IFN-M2"
  | "IFN-M3"
  | "IFN-M4"
  | "IFN-M"
  | "IFN-SM"
  | "IFN-UK"
  | "IFN-JK"
  | "IFN-SK"
  | "IFN-K1"
  | "IFN-K2"
  | "IFN-K3"
  | "IFN-K4"
  | "IFN-KM";

/**
 * * `good` - good
 * * `failed` - failed
 * * `` -
 */
export type LiftAttemptStatusEnum = "good" | "failed";

/**
 * * `active` - Aktiv
 * * `warned` - Varnad
 * * `suspended` - Avstängd
 * * `unknown` - Okänd
 */
export type JudgeStatusEnum = "active" | "warned" | "suspended" | "unknown";

/** * `ok` - ok */
export type HealthOKStatusEnum = "ok";

/** * `error` - error */
export type HealthErrorStatusEnum = "error";

/**
 * * `M` - Herr
 * * `F` - Dam
 * * `B` - Blandat
 */
export type GenderEnum = "M" | "F" | "B";

/**
 * * `sq` - Knäböj
 * * `bp` - Bänkpress
 * * `dl` - Marklyft
 * * `total` - Sammanlagt
 */
export type DisciplineEnum = "sq" | "bp" | "dl" | "total";

/**
 * * `CPL` - Klassisk Styrkelyft
 * * `CBP` - Klassisk Bänkpress
 * * `EPL` - Utrustad Styrkelyft
 * * `EBP` - Utrustad Bänkpress
 * * `PBP` - Parabänkpress
 * * `SPL` - IFN Styrkelyft
 */
export type CompetitionTypeNameEnum =
  | "CPL"
  | "CBP"
  | "EPL"
  | "EBP"
  | "PBP"
  | "SPL";

/**
 * * `CREATED` - Created
 * * `PUBLISHED` - Published
 * * `CLOSED` - Closed
 * * `ARCHIVED` - Archived
 */
export type CompetitionStateEnum =
  | "CREATED"
  | "PUBLISHED"
  | "CLOSED"
  | "ARCHIVED";

/**
 * * `WG` - World Games
 * * `VM` - VM
 * * `EM` - EM
 * * `NM` - NM
 * * `INT` - Internationell
 * * `SM` - SM
 * * `RM` - RM
 * * `LDM` - LDM
 * * `DM` - DM
 * * `GENERAL` - Serie/Övrig
 * * `KM` - KM
 */
export type CompetitionCategoryEnum =
  | "WG"
  | "VM"
  | "EM"
  | "NM"
  | "INT"
  | "SM"
  | "RM"
  | "LDM"
  | "DM"
  | "GENERAL"
  | "KM";

export type BlankEnum = "";

/**
 * * `chief_referee` - chief_referee
 * * `side_referee` - side_referee
 * * `jury` - jury
 * * `speaker` - speaker
 * * `technical_controller` - technical_controller
 * * `meet_director` - meet_director
 */
export type AssignmentEnum =
  | "chief_referee"
  | "side_referee"
  | "jury"
  | "speaker"
  | "technical_controller"
  | "meet_director";

/**
 * * `K` - U11-13
 * * `U` - Ungdom
 * * `J` - Junior
 * * `S` - Senior
 * * `M1` - Veteran (40-49 år)
 * * `M2` - Veteran (50-59 år)
 * * `M3` - Veteran (60-69 år)
 * * `M4` - Veteran (70+ år)
 * * `SM` - Veteran IFN
 * * `PU` - Ungdom Para
 * * `PJ` - Junior Para
 * * `PS` - Senior Para
 * * `PM` - Veteran Para
 */
export type AgeCategoryNameEnum =
  | "K"
  | "U"
  | "J"
  | "S"
  | "M1"
  | "M2"
  | "M3"
  | "M4"
  | "SM"
  | "PU"
  | "PJ"
  | "PS"
  | "PM";

export interface AddClubAdminRequestRequest {
  /**
   * @format email
   * @minLength 1
   */
  email: string;
}

export interface AddClubAdminResponse {
  status: string;
}

export interface AddCompetitionAdminRequestRequest {
  /**
   * @format email
   * @minLength 1
   */
  email: string;
}

export interface AddCompetitionAdminResponse {
  status: string;
}

export interface AddDistrictAdminRequestRequest {
  /**
   * @format email
   * @minLength 1
   */
  email: string;
}

export interface AddDistrictAdminResponse {
  status: string;
}

export interface AgeCategory {
  id: number;
  /**
   * * `K` - U11-13
   * * `U` - Ungdom
   * * `J` - Junior
   * * `S` - Senior
   * * `M1` - Veteran (40-49 år)
   * * `M2` - Veteran (50-59 år)
   * * `M3` - Veteran (60-69 år)
   * * `M4` - Veteran (70+ år)
   * * `SM` - Veteran IFN
   * * `PU` - Ungdom Para
   * * `PJ` - Junior Para
   * * `PS` - Senior Para
   * * `PM` - Veteran Para
   */
  name: AgeCategoryNameEnum;
  label: string;
  /**
   * @min 0
   * @max 2147483647
   */
  min_age: number;
  /**
   * @min 0
   * @max 2147483647
   */
  max_age: number;
  is_archived: boolean;
  competition_types: CompetitionType[];
}

export interface AgeCategorySerializerSmall {
  id: number;
  /**
   * * `K` - U11-13
   * * `U` - Ungdom
   * * `J` - Junior
   * * `S` - Senior
   * * `M1` - Veteran (40-49 år)
   * * `M2` - Veteran (50-59 år)
   * * `M3` - Veteran (60-69 år)
   * * `M4` - Veteran (70+ år)
   * * `SM` - Veteran IFN
   * * `PU` - Ungdom Para
   * * `PJ` - Junior Para
   * * `PS` - Senior Para
   * * `PM` - Veteran Para
   */
  name: AgeCategoryNameEnum;
  label: string;
}

export interface AuthTokenRequest {
  /** @minLength 1 */
  username: string;
  /** @minLength 1 */
  password: string;
}

export interface CDSAgeCategory {
  /** ID of the age category. */
  id: number;
  /** Name of the age category. */
  name: string;
  /** Display label of the age category. */
  label: string;
  /** List of weight classes under this age category. */
  weight_classes: CDSWeightClass[];
  /** Points system used for this age category and competition type. */
  points_system: string;
}

export interface CDSCompetitionType {
  /** ID of the competition type. */
  id: number;
  /** Name of the competition type. */
  name: string;
  /** Display label of the competition type. */
  label: string;
  /** List of age categories under this competition type. */
  age_categories: CDSAgeCategory[];
}

export interface CDSWeightClass {
  /** ID of the weight class. */
  id: number;
  /** Name of the weight class. */
  name: string;
  /** Indicates if this is a male weight class. */
  is_male: boolean;
  /** List of competition results for this weight class. */
  results: CompetitionResult[];
}

/** Used for ``changed_by`` fields in history responses. */
export interface ChangedBy {
  id: number;
  /** @format email */
  email: string;
  first_name: string;
  last_name: string;
}

export interface Club {
  id: number;
  /**
   * Name of club
   * @maxLength 100
   */
  name: string;
  /**
   * Swedish Organization Number of club on the form XXXXXX-XXXX
   * @maxLength 11
   */
  orgnr?: string | null;
  /**
   * Club number assigned by RF, 4-5 digit number
   * @min 1000
   * @max 99999
   */
  rfnr?: number | null;
  /** E-mail of club */
  email?: string | null;
  /** Website of club */
  website?: string | null;
  district: DistrictSerializerSmall;
  /** Flags if club is active */
  is_active?: boolean;
}

export interface ClubDistrict {
  id: number;
  /** Name of club */
  name: string;
  district: DistrictSerializerSmall;
}

export interface ClubSerializerSmall {
  id: number;
  /**
   * Name of club
   * @maxLength 100
   */
  name: string;
}

export interface ClubSerializerSmallRequest {
  /**
   * Name of club
   * @minLength 1
   * @maxLength 100
   */
  name: string;
}

export interface ClubWriteRequest {
  /**
   * Name of club
   * @minLength 1
   * @maxLength 100
   */
  name: string;
  /** E-mail of club */
  email?: string | null;
  /** Website of club */
  website?: string | null;
  district?: number | null;
  /** Flags if club is active */
  is_active?: boolean;
}

export interface Competition {
  id: number;
  /** @maxLength 100 */
  name: string;
  /** @format date */
  start_date?: string | null;
  /** @format date */
  end_date?: string | null;
  /**
   * * `WG` - World Games
   * * `VM` - VM
   * * `EM` - EM
   * * `NM` - NM
   * * `INT` - Internationell
   * * `SM` - SM
   * * `RM` - RM
   * * `LDM` - LDM
   * * `DM` - DM
   * * `GENERAL` - Serie/Övrig
   * * `KM` - KM
   */
  category?: CompetitionCategoryEnum;
  /**
   * * `CREATED` - Created
   * * `PUBLISHED` - Published
   * * `CLOSED` - Closed
   * * `ARCHIVED` - Archived
   */
  state?: CompetitionStateEnum;
  /** @format date-time */
  reg_deadline?: string | null;
  /** Specifies if the competition is open for external registrations */
  open_externally?: boolean;
  /** Marks whether this competition is team-based. */
  is_team_comp?: boolean;
  /**
   * Maximum number of registrations allowed when open_externally is true. NULL means no limit.
   * @min 0
   * @max 2147483647
   */
  registrations_limit?: number | null;
  /** Organizer name(s) */
  organizer?: string | null;
  /** Contact First Name */
  contact_first_name?: string | null;
  /** Contact Last Name */
  contact_last_name?: string | null;
  /** Contact Email */
  contact_email?: string | null;
  /**
   * Contact Phone
   * @maxLength 128
   */
  contact_phone?: string | null;
  /** Payment info/nr/account */
  payment_info?: string | null;
  /** Location (City or City Country) */
  location?: string | null;
  /** Districts the competition is associated with */
  districts?: number[];
}

export interface CompetitionCategory {
  name: string;
  description: string;
}

export interface CompetitionDetail {
  id: number;
  /** @maxLength 100 */
  name: string;
  /** @format date */
  start_date?: string | null;
  /** @format date */
  end_date?: string | null;
  /**
   * * `WG` - World Games
   * * `VM` - VM
   * * `EM` - EM
   * * `NM` - NM
   * * `INT` - Internationell
   * * `SM` - SM
   * * `RM` - RM
   * * `LDM` - LDM
   * * `DM` - DM
   * * `GENERAL` - Serie/Övrig
   * * `KM` - KM
   */
  category?: CompetitionCategoryEnum;
  /**
   * * `CREATED` - Created
   * * `PUBLISHED` - Published
   * * `CLOSED` - Closed
   * * `ARCHIVED` - Archived
   */
  state?: CompetitionStateEnum;
  /** @format date-time */
  reg_deadline?: string | null;
  /** Specifies if the competition is open for external registrations */
  open_externally?: boolean;
  /** Marks whether this competition is team-based. */
  is_team_comp?: boolean;
  /**
   * Maximum number of registrations allowed when open_externally is true. NULL means no limit.
   * @min 0
   * @max 2147483647
   */
  registrations_limit?: number | null;
  registrations_count: number;
  registration_open: boolean;
  /** Organizer name(s) */
  organizer?: string | null;
  /** Contact First Name */
  contact_first_name?: string | null;
  /** Contact Last Name */
  contact_last_name?: string | null;
  /** Contact Email */
  contact_email?: string | null;
  /**
   * Contact Phone
   * @maxLength 128
   */
  contact_phone?: string | null;
  /** Payment info/nr/account */
  payment_info?: string | null;
  /** Location (City or City Country) */
  location?: string | null;
  files: CompetitionFile[];
  registration_categories: number[];
  groups: number[];
  results: CDSCompetitionType[];
  api_key: string | null;
  districts: DistrictSerializerSmall[];
}

export interface CompetitionDivision {
  id: number;
  competition: CompetitionSerializerSmall;
  /** @maxLength 100 */
  name: string;
  competition_type: CompetitionType;
  age_categories: AgeCategorySerializerSmall[];
  /**
   * * `IPFGL` - IPFGL
   * * `IPFGL_MALE` - IPFGL Herr
   * * `IPF` - IPF
   * * `IPF_MALE` - IPF Herr
   * * `WILKS` - WILKS
   * * `WILKS_MALE` - WILKS Herr
   * * `DOTS` - DOTS
   * * `DOTS_MALE` - DOTS Herr
   */
  scoring_system: ScoringSystemEnum;
  /** @format date */
  nomination_start_date?: string | null;
  /** @format date */
  nomination_end_date?: string | null;
  /**
   * * `M` - Herr
   * * `F` - Dam
   * * `B` - Blandat
   */
  gender?: GenderEnum;
  /**
   * @min 0
   * @max 32767
   */
  lifters_per_team: number;
  /**
   * @min 0
   * @max 32767
   */
  reserve_slots?: number;
  /**
   * @min 0
   * @max 32767
   */
  min_female_lifters?: number;
  /**
   * @min 0
   * @max 32767
   */
  min_male_lifters?: number;
  source_series_division: SourceSeriesDivision | null;
}

export interface CompetitionDivisionSerializerSmall {
  id: number;
  /** @maxLength 100 */
  name: string;
  /**
   * * `IPFGL` - IPFGL
   * * `IPFGL_MALE` - IPFGL Herr
   * * `IPF` - IPF
   * * `IPF_MALE` - IPF Herr
   * * `WILKS` - WILKS
   * * `WILKS_MALE` - WILKS Herr
   * * `DOTS` - DOTS
   * * `DOTS_MALE` - DOTS Herr
   */
  scoring_system: ScoringSystemEnum;
}

export interface CompetitionDivisionWriteRequest {
  competition: number;
  /**
   * @minLength 1
   * @maxLength 100
   */
  name: string;
  competition_type: number;
  age_categories?: number[];
  /**
   * * `IPFGL` - IPFGL
   * * `IPFGL_MALE` - IPFGL Herr
   * * `IPF` - IPF
   * * `IPF_MALE` - IPF Herr
   * * `WILKS` - WILKS
   * * `WILKS_MALE` - WILKS Herr
   * * `DOTS` - DOTS
   * * `DOTS_MALE` - DOTS Herr
   */
  scoring_system: ScoringSystemEnum;
  /** @format date */
  nomination_start_date?: string | null;
  /** @format date */
  nomination_end_date?: string | null;
  /**
   * * `M` - Herr
   * * `F` - Dam
   * * `B` - Blandat
   */
  gender: GenderEnum;
  /**
   * @min 0
   * @max 32767
   */
  lifters_per_team: number;
  /**
   * @min 0
   * @max 32767
   */
  reserve_slots?: number;
  /**
   * @min 0
   * @max 32767
   */
  min_female_lifters?: number;
  /**
   * @min 0
   * @max 32767
   */
  min_male_lifters?: number;
  source_series_division?: number | null;
}

export interface CompetitionFile {
  /** @format uuid */
  id: string;
  /** @maxLength 100 */
  name: string;
  /** @format uri */
  file: string;
  competition: number | null;
  uploaded_by: number | null;
  /** @format date-time */
  uploaded_at: string;
}

export interface CompetitionFileRequest {
  /**
   * @minLength 1
   * @maxLength 100
   */
  name: string;
  /** @format binary */
  file: File;
}

export interface CompetitionList {
  id: number;
  /** @maxLength 100 */
  name: string;
  /** @format date */
  start_date?: string | null;
  /** @format date */
  end_date?: string | null;
  /**
   * * `WG` - World Games
   * * `VM` - VM
   * * `EM` - EM
   * * `NM` - NM
   * * `INT` - Internationell
   * * `SM` - SM
   * * `RM` - RM
   * * `LDM` - LDM
   * * `DM` - DM
   * * `GENERAL` - Serie/Övrig
   * * `KM` - KM
   */
  category?: CompetitionCategoryEnum;
  /**
   * * `CREATED` - Created
   * * `PUBLISHED` - Published
   * * `CLOSED` - Closed
   * * `ARCHIVED` - Archived
   */
  state?: CompetitionStateEnum;
  /** @format date-time */
  reg_deadline?: string | null;
  /** Specifies if the competition is open for external registrations */
  open_externally?: boolean;
  /** Marks whether this competition is team-based. */
  is_team_comp?: boolean;
  /**
   * Maximum number of registrations allowed when open_externally is true. NULL means no limit.
   * @min 0
   * @max 2147483647
   */
  registrations_limit?: number | null;
  registrations_count: number;
  /** Organizer name(s) */
  organizer?: string | null;
  /** Location (City or City Country) */
  location?: string | null;
  registration_open: boolean;
  districts: DistrictSerializerSmall[];
}

export interface CompetitionRequest {
  /**
   * @minLength 1
   * @maxLength 100
   */
  name: string;
  /** @format date */
  start_date?: string | null;
  /** @format date */
  end_date?: string | null;
  /**
   * * `WG` - World Games
   * * `VM` - VM
   * * `EM` - EM
   * * `NM` - NM
   * * `INT` - Internationell
   * * `SM` - SM
   * * `RM` - RM
   * * `LDM` - LDM
   * * `DM` - DM
   * * `GENERAL` - Serie/Övrig
   * * `KM` - KM
   */
  category?: CompetitionCategoryEnum;
  /**
   * * `CREATED` - Created
   * * `PUBLISHED` - Published
   * * `CLOSED` - Closed
   * * `ARCHIVED` - Archived
   */
  state?: CompetitionStateEnum;
  /** @format date-time */
  reg_deadline?: string | null;
  /** Specifies if the competition is open for external registrations */
  open_externally?: boolean;
  /** Marks whether this competition is team-based. */
  is_team_comp?: boolean;
  /**
   * Maximum number of registrations allowed when open_externally is true. NULL means no limit.
   * @min 0
   * @max 2147483647
   */
  registrations_limit?: number | null;
  /** Organizer name(s) */
  organizer?: string | null;
  /** Contact First Name */
  contact_first_name?: string | null;
  /** Contact Last Name */
  contact_last_name?: string | null;
  /** Contact Email */
  contact_email?: string | null;
  /**
   * Contact Phone
   * @maxLength 128
   */
  contact_phone?: string | null;
  /** Payment info/nr/account */
  payment_info?: string | null;
  /** Location (City or City Country) */
  location?: string | null;
  files?: string[];
  /** Districts the competition is associated with */
  districts?: number[];
}

export interface CompetitionResult {
  id: number;
  person: PersonResult;
  club: ClubDistrict;
  team: CompetitionTeam | null;
  division: CompetitionDivisionSerializerSmall | null;
  competition_type: CompetitionType;
  age_category: AgeCategorySerializerSmall;
  weight_class: WeightClassResult;
  /**
   * @format double
   * @min -1000
   * @exclusiveMin true
   * @max 1000
   * @exclusiveMax true
   */
  body_weight: number;
  /**
   * @format double
   * @min -10000
   * @exclusiveMin true
   * @max 10000
   * @exclusiveMax true
   */
  squat: number | null;
  /**
   * @format double
   * @min -10000
   * @exclusiveMin true
   * @max 10000
   * @exclusiveMax true
   */
  benchpress: number | null;
  /**
   * @format double
   * @min -10000
   * @exclusiveMin true
   * @max 10000
   * @exclusiveMax true
   */
  deadlift: number | null;
  /**
   * @format double
   * @min -10000
   * @exclusiveMin true
   * @max 10000
   * @exclusiveMax true
   */
  total: number;
  /** @format double */
  points: number;
  /**
   * @min 0
   * @max 2147483647
   */
  lot?: number | null;
  /**
   * @min 0
   * @max 2147483647
   */
  rank?: number | null;
  already_in_round?: boolean | null;
}

export interface CompetitionSerializerLevel {
  id: number;
  /** @maxLength 100 */
  name: string;
  /**
   * * `WG` - World Games
   * * `VM` - VM
   * * `EM` - EM
   * * `NM` - NM
   * * `INT` - Internationell
   * * `SM` - SM
   * * `RM` - RM
   * * `LDM` - LDM
   * * `DM` - DM
   * * `GENERAL` - Serie/Övrig
   * * `KM` - KM
   */
  category?: CompetitionCategoryEnum;
}

export interface CompetitionSerializerSmall {
  id: number;
  /** @maxLength 100 */
  name: string;
}

export interface CompetitionSerializerSmallRequest {
  /**
   * @minLength 1
   * @maxLength 100
   */
  name: string;
}

export interface CompetitionTeam {
  id: number;
  division: CompetitionDivisionSerializerSmall;
  /** @maxLength 100 */
  name: string;
  club: ClubDistrict | null;
}

export interface CompetitionTeamDetail {
  id: number;
  /** @maxLength 100 */
  name: string;
  /** @format date */
  start_date?: string | null;
  /** @format date */
  end_date?: string | null;
  /**
   * * `WG` - World Games
   * * `VM` - VM
   * * `EM` - EM
   * * `NM` - NM
   * * `INT` - Internationell
   * * `SM` - SM
   * * `RM` - RM
   * * `LDM` - LDM
   * * `DM` - DM
   * * `GENERAL` - Serie/Övrig
   * * `KM` - KM
   */
  category?: CompetitionCategoryEnum;
  /**
   * * `CREATED` - Created
   * * `PUBLISHED` - Published
   * * `CLOSED` - Closed
   * * `ARCHIVED` - Archived
   */
  state?: CompetitionStateEnum;
  /** @format date-time */
  reg_deadline?: string | null;
  /** Specifies if the competition is open for external registrations */
  open_externally?: boolean;
  /** Marks whether this competition is team-based. */
  is_team_comp?: boolean;
  /**
   * Maximum number of registrations allowed when open_externally is true. NULL means no limit.
   * @min 0
   * @max 2147483647
   */
  registrations_limit?: number | null;
  registrations_count: number;
  registration_open: boolean;
  /** Organizer name(s) */
  organizer?: string | null;
  /** Contact First Name */
  contact_first_name?: string | null;
  /** Contact Last Name */
  contact_last_name?: string | null;
  /** Contact Email */
  contact_email?: string | null;
  /**
   * Contact Phone
   * @maxLength 128
   */
  contact_phone?: string | null;
  /** Payment info/nr/account */
  payment_info?: string | null;
  /** Location (City or City Country) */
  location?: string | null;
  files: CompetitionFile[];
  registration_categories: number[];
  groups: number[];
  results: CompetitionTeamDetailDivisionEntry[];
  api_key: string | null;
  districts: DistrictSerializerSmall[];
}

export interface CompetitionTeamDetailDivisionEntry {
  id?: number;
  name?: string;
  competition_type?: CompetitionType;
  age_categories?: AgeCategorySerializerSmall[];
  scoring_system?: string;
  /** @format date */
  nomination_start_date?: string | null;
  /** @format date */
  nomination_end_date?: string | null;
  /**
   * * `M` - Herr
   * * `F` - Dam
   * * `B` - Blandat
   */
  gender?: GenderEnum;
  lifters_per_team?: number;
  reserve_slots?: number;
  min_female_lifters?: number;
  min_male_lifters?: number;
  source_series_division?: SourceSeriesDivision | null;
  teams: CompetitionTeamDetailTeamEntry[];
}

export interface CompetitionTeamDetailTeamEntry {
  rank: number;
  /** @format double */
  team_points: number;
  team: CompetitionTeamSerializerSmall | null;
  results: CompetitionResult[];
}

export interface CompetitionTeamSerializerSmall {
  id: number;
  /** @maxLength 100 */
  name: string;
  club: ClubDistrict | null;
}

export interface CompetitionTeamWriteRequest {
  division: number;
  /**
   * @minLength 1
   * @maxLength 100
   */
  name: string;
  club?: number | null;
}

export interface CompetitionType {
  id: number;
  /**
   * * `CPL` - Klassisk Styrkelyft
   * * `CBP` - Klassisk Bänkpress
   * * `EPL` - Utrustad Styrkelyft
   * * `EBP` - Utrustad Bänkpress
   * * `PBP` - Parabänkpress
   * * `SPL` - IFN Styrkelyft
   */
  name: CompetitionTypeNameEnum;
  description: string;
}

export interface CompetitionTypeWC {
  id: number;
  /**
   * * `CPL` - Klassisk Styrkelyft
   * * `CBP` - Klassisk Bänkpress
   * * `EPL` - Utrustad Styrkelyft
   * * `EBP` - Utrustad Bänkpress
   * * `PBP` - Parabänkpress
   * * `SPL` - IFN Styrkelyft
   */
  name: CompetitionTypeNameEnum;
  description: string;
  age_categories: AgeCategorySerializerSmall[];
}

export interface District {
  id: number;
  /**
   * Full name of the district
   * @maxLength 100
   */
  name: string;
  /** @maxLength 11 */
  orgnr?: string | null;
  /**
   * @min 0
   * @max 99999
   */
  rfnr?: number | null;
  /** E-mail of District */
  email?: string | null;
  website?: string | null;
  region: Region;
}

export interface DistrictSerializerSmall {
  id: number;
  /**
   * Full name of the district
   * @maxLength 100
   */
  name: string;
}

export interface DistrictSerializerSmallRequest {
  /**
   * Full name of the district
   * @minLength 1
   * @maxLength 100
   */
  name: string;
}

export interface DistrictWriteRequest {
  /**
   * Full name of the district
   * @minLength 1
   * @maxLength 100
   */
  name: string;
  /** @maxLength 11 */
  orgnr?: string | null;
  /**
   * @min 0
   * @max 99999
   */
  rfnr?: number | null;
  /** E-mail of District */
  email?: string | null;
  website?: string | null;
  region?: number | null;
}

export interface Division {
  id: number;
  series: SeriesSerializerSmall;
  name: string;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  results_per_round: number;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  max_teams: number;
  /**
   * @min 1
   * @max 2147483647
   */
  level: number;
  rounds: Round[];
}

export interface DivisionDetailed {
  id: number;
  series: SeriesSerializerSmall;
  name: string;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  results_per_round: number;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  max_teams: number;
  /**
   * @min 1
   * @max 2147483647
   */
  level: number;
  rounds: Round[];
  teams: Team[];
}

export interface DivisionSerializerSmall {
  id: number;
  name: string;
  series: SeriesSerializerSmall;
}

export interface DivisionWriteRequest {
  series: number;
  /** @minLength 1 */
  name: string;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  results_per_round: number;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  max_teams: number;
  /**
   * @min 1
   * @max 2147483647
   */
  level: number;
  rounds: number[];
}

export interface ErrorResponse {
  reason: string;
}

export interface Group {
  id: number;
  competition: CompetitionSerializerSmall;
  /** @maxLength 50 */
  name?: string | null;
  /** @format date-time */
  start?: string | null;
}

export interface GroupDetail {
  id: number;
  competition: CompetitionSerializerSmall;
  /** @maxLength 50 */
  name?: string | null;
  /** @format date-time */
  start?: string | null;
  results: CompetitionResult[];
}

export interface GroupRequest {
  /** @minLength 1 */
  name: string;
  /** @format date-time */
  start: string;
  results: ResultRequest[];
  referees?: RefereeRequest[];
}

export interface GroupWriteRequest {
  competition?: number | null;
  /** @maxLength 50 */
  name?: string | null;
  /** @format date-time */
  start: string;
}

export interface HealthError {
  /**
   * Health status indicator
   *
   * * `error` - error
   */
  status: HealthErrorStatusEnum;
  /** Human-readable error cause */
  detail: string;
}

export interface HealthOK {
  /**
   * Health status indicator
   *
   * * `ok` - ok
   */
  status: HealthOKStatusEnum;
}

export interface Judge {
  id: number;
  /**
   * @min 0
   * @max 2147483647
   */
  book?: number | null;
  /**
   * * `active` - Aktiv
   * * `warned` - Varnad
   * * `suspended` - Avstängd
   * * `unknown` - Okänd
   */
  status?: JudgeStatusEnum;
  person: PersonClubDistrict;
  club: ClubDistrict;
  year: number | null;
  year_para: number | null;
  is_para: boolean;
  is_non_para: boolean;
  recent_level: RecentLevelParaEnum;
  recent_level_para: RecentLevelParaEnum;
  duty_summary: {
    /** Number of duties performed calssified as "primary". */
    primary?: number;
    /** Number of duties performed calssified as "secondary". */
    secondary?: number;
    /** Number of duties performed including a full powerlifting result */
    SL?: number;
    /** Number of duties performed including only benchpress results */
    BP?: number;
    /** Number of duties performed as head judge */
    HD?: number;
    /** Number of duties performed as side judge */
    SD?: number;
    /** Number of duties performed as a technical-controller */
    TK?: number;
    /** Number of duties performed as a competiton manager/leader */
    TL?: number;
    /** Number of duties performed as a juror */
    JU?: number;
    /** Number of duties performed as a speaker */
    SP?: number;
  } | null;
  duty_summary_para: {
    /** Number of duties performed calssified as "primary". */
    primary?: number;
    /** Number of duties performed calssified as "secondary". */
    secondary?: number;
    /** Number of duties performed including a full powerlifting result */
    SL?: number;
    /** Number of duties performed including only benchpress results */
    BP?: number;
    /** Number of duties performed as head judge */
    HD?: number;
    /** Number of duties performed as side judge */
    SD?: number;
    /** Number of duties performed as a technical-controller */
    TK?: number;
    /** Number of duties performed as a competiton manager/leader */
    TL?: number;
    /** Number of duties performed as a juror */
    JU?: number;
    /** Number of duties performed as a speaker */
    SP?: number;
  } | null;
}

export interface JudgeDuty {
  id: number;
  judge_license: JudgeLicense;
  role: JudgeRoles;
  group: JudgeDutyGroup;
}

export interface JudgeDutyGroup {
  id: number;
  /** @format date */
  date: string;
  name: string | null;
  competition: CompetitionSerializerLevel;
}

export interface JudgeDutyWriteRequest {
  judge: number;
  /**
   * * `HD` - Huvuddomare
   * * `SD` - Sidodomare
   * * `TK` - Teknisk Kontrollant
   * * `TL` - Tävlingsledare
   * * `JU` - Jury
   * * `SP` - Speaker
   * * `IN` - Instruktör
   */
  role: RoleEnum;
  group: number;
}

export interface JudgeLicense {
  id: number;
  judge: JudgeSerializerSmall;
  club: ClubSerializerSmall;
  /**
   * Issue date and start of validity
   * @format date
   */
  start_date: string;
  /**
   * Date of license expiry
   * @format date
   */
  end_date: string;
  /**
   * * `D` - Distriktsdomare
   * * `F` - Förbundsdomare
   * * `K2` - Kat 2. Domare
   * * `K1` - Kat 1. Domare
   */
  level: RecentLevelParaEnum;
  is_para?: boolean;
}

export interface JudgeLicenseSerializerDetailedGet {
  id: number;
  judge: JudgeSerializerSmall;
  club: ClubSerializerSmall;
  /**
   * Issue date and start of validity
   * @format date
   */
  start_date: string;
  /**
   * Date of license expiry
   * @format date
   */
  end_date: string;
  /**
   * * `D` - Distriktsdomare
   * * `F` - Förbundsdomare
   * * `K2` - Kat 2. Domare
   * * `K1` - Kat 1. Domare
   */
  level: RecentLevelParaEnum;
  is_para?: boolean;
  duty_summary: {
    /** Number of duties performed calssified as "primary". */
    primary?: number;
    /** Number of duties performed calssified as "secondary". */
    secondary?: number;
    /** Number of duties performed including a full powerlifting result */
    SL?: number;
    /** Number of duties performed including only benchpress results */
    BP?: number;
    /** Number of duties performed as head judge */
    HD?: number;
    /** Number of duties performed as side judge */
    SD?: number;
    /** Number of duties performed as a technical-controller */
    TK?: number;
    /** Number of duties performed as a competiton manager/leader */
    TL?: number;
    /** Number of duties performed as a juror */
    JU?: number;
    /** Number of duties performed as a speaker */
    SP?: number;
  } | null;
  duties: JudgeDuty[];
}

export interface JudgeLicenseWrite {
  id: number;
  judge: number;
  club?: number | null;
  /**
   * Issue date and start of validity
   * @format date
   */
  start_date?: string;
  /**
   * Date of license expiry
   * @format date
   */
  end_date?: string;
  /**
   * * `D` - Distriktsdomare
   * * `F` - Förbundsdomare
   * * `K2` - Kat 2. Domare
   * * `K1` - Kat 1. Domare
   */
  level?: RecentLevelParaEnum;
  is_para?: boolean;
}

export interface JudgeLicenseWriteRequest {
  judge: number;
  club?: number | null;
  /**
   * Issue date and start of validity
   * @format date
   */
  start_date?: string;
  /**
   * Date of license expiry
   * @format date
   */
  end_date?: string;
  /**
   * * `D` - Distriktsdomare
   * * `F` - Förbundsdomare
   * * `K2` - Kat 2. Domare
   * * `K1` - Kat 1. Domare
   */
  level?: RecentLevelParaEnum;
  is_para?: boolean;
}

export interface JudgeRoles {
  name: string;
  description: string;
}

export interface JudgeSerializerDetailed {
  id: number;
  /**
   * @min 0
   * @max 2147483647
   */
  book?: number | null;
  /**
   * * `active` - Aktiv
   * * `warned` - Varnad
   * * `suspended` - Avstängd
   * * `unknown` - Okänd
   */
  status?: JudgeStatusEnum;
  person: PersonClubDistrict;
  year: number | null;
  year_para: number | null;
  is_para: boolean;
  is_non_para: boolean;
  recent_level: RecentLevelParaEnum | null;
  recent_level_para: RecentLevelParaEnum | null;
  duty_summary: {
    /** Number of duties performed calssified as "primary". */
    primary?: number;
    /** Number of duties performed calssified as "secondary". */
    secondary?: number;
    /** Number of duties performed including a full powerlifting result */
    SL?: number;
    /** Number of duties performed including only benchpress results */
    BP?: number;
    /** Number of duties performed as head judge */
    HD?: number;
    /** Number of duties performed as side judge */
    SD?: number;
    /** Number of duties performed as a technical-controller */
    TK?: number;
    /** Number of duties performed as a competiton manager/leader */
    TL?: number;
    /** Number of duties performed as a juror */
    JU?: number;
    /** Number of duties performed as a speaker */
    SP?: number;
  } | null;
  duty_summary_para: {
    /** Number of duties performed calssified as "primary". */
    primary?: number;
    /** Number of duties performed calssified as "secondary". */
    secondary?: number;
    /** Number of duties performed including a full powerlifting result */
    SL?: number;
    /** Number of duties performed including only benchpress results */
    BP?: number;
    /** Number of duties performed as head judge */
    HD?: number;
    /** Number of duties performed as side judge */
    SD?: number;
    /** Number of duties performed as a technical-controller */
    TK?: number;
    /** Number of duties performed as a competiton manager/leader */
    TL?: number;
    /** Number of duties performed as a juror */
    JU?: number;
    /** Number of duties performed as a speaker */
    SP?: number;
  } | null;
}

export interface JudgeSerializerDetailedGet {
  id: number;
  /**
   * @min 0
   * @max 2147483647
   */
  book?: number | null;
  /**
   * * `active` - Aktiv
   * * `warned` - Varnad
   * * `suspended` - Avstängd
   * * `unknown` - Okänd
   */
  status?: JudgeStatusEnum;
  person: PersonClubDistrict;
  year: number | null;
  year_para: number | null;
  judge_licenses: JudgeLicenseSerializerDetailedGet[];
  is_para: boolean;
  is_non_para: boolean;
  recent_level: RecentLevelParaEnum | null;
  recent_level_para: RecentLevelParaEnum | null;
}

export interface JudgeSerializerGet {
  id: number;
  /**
   * @min 0
   * @max 2147483647
   */
  book?: number | null;
  /**
   * * `active` - Aktiv
   * * `warned` - Varnad
   * * `suspended` - Avstängd
   * * `unknown` - Okänd
   */
  status?: JudgeStatusEnum;
  person: PersonClubDistrict;
  club: ClubDistrict;
  year: number | null;
  year_para: number | null;
  is_para: boolean;
  is_non_para: boolean;
  recent_level: RecentLevelParaEnum;
  recent_level_para: RecentLevelParaEnum;
  judge_licenses: JudgeLicenseSerializerDetailedGet[];
}

export interface JudgeSerializerSmall {
  id: number;
  /**
   * @min 0
   * @max 2147483647
   */
  book?: number | null;
  person: PersonSerializerSmall;
}

export interface JudgeWrite {
  id: number;
  /**
   * @min 0
   * @max 2147483647
   */
  book?: number | null;
  /**
   * * `active` - Aktiv
   * * `warned` - Varnad
   * * `suspended` - Avstängd
   * * `unknown` - Okänd
   */
  status?: JudgeStatusEnum;
  person: number;
}

export interface JudgeWriteRequest {
  /**
   * @min 0
   * @max 2147483647
   */
  book?: number | null;
  /**
   * * `active` - Aktiv
   * * `warned` - Varnad
   * * `suspended` - Avstängd
   * * `unknown` - Okänd
   */
  status?: JudgeStatusEnum;
  person: number;
}

export interface License {
  id: number;
  person: number;
  club?: ClubSerializerSmall;
  /**
   * Issue date and start of validity
   * @format date
   */
  start_date?: string;
  /**
   * Date of license expiry
   * @format date
   */
  end_date?: string;
  license_id: string;
}

export interface LicenseWrite {
  id: number;
  person: number;
  club?: number;
  /**
   * Issue date and start of validity
   * @format date
   */
  start_date?: string;
  /**
   * Date of license expiry
   * @format date
   */
  end_date?: string;
}

export interface LicenseWriteRequest {
  person: number;
  club?: number;
  /**
   * Issue date and start of validity
   * @format date
   */
  start_date?: string;
  /**
   * Date of license expiry
   * @format date
   */
  end_date?: string;
}

export interface LiftAttemptRequest {
  attempt: number;
  /** @format double */
  weight: number;
  status: LiftAttemptStatusEnum | BlankEnum;
}

export interface LiftResult {
  /**
   * @format double
   * @min -10000
   * @exclusiveMin true
   * @max 10000
   * @exclusiveMax true
   */
  result: number;
  /** @format date */
  date: string;
  /**
   * @format double
   * @min -1000
   * @exclusiveMin true
   * @max 1000
   * @exclusiveMax true
   */
  body_weight: number;
  result_id: number;
}

export interface LifterRequest {
  /** @minLength 1 */
  license: string;
  category?: LifterCategoryEnum | NullEnum | null;
  /** @format double */
  body_weight: number;
  /**
   * * `male` - male
   * * `female` - female
   */
  sex?: LifterSexEnum;
  lot: number;
  equipped?: boolean | null;
  type?: LifterTypeEnum | NullEnum | null;
  /** @min 1 */
  competition_team_id?: number | null;
}

export interface LifterResult {
  id: number;
  /** @format date-time */
  date: string;
  club: ClubDistrict;
  competition: CompetitionSerializerLevel;
  competition_type: CompetitionType;
  age_category: AgeCategorySerializerSmall;
  weight_class: WeightClassResult;
  /**
   * @format double
   * @min -1000
   * @exclusiveMin true
   * @max 1000
   * @exclusiveMax true
   */
  body_weight: number;
  /**
   * @format double
   * @min -10000
   * @exclusiveMin true
   * @max 10000
   * @exclusiveMax true
   */
  squat: number | null;
  /**
   * @format double
   * @min -10000
   * @exclusiveMin true
   * @max 10000
   * @exclusiveMax true
   */
  benchpress: number | null;
  /**
   * @format double
   * @min -10000
   * @exclusiveMin true
   * @max 10000
   * @exclusiveMax true
   */
  deadlift: number | null;
  /**
   * @format double
   * @min -10000
   * @exclusiveMin true
   * @max 10000
   * @exclusiveMax true
   */
  total: number;
  /** @format double */
  points: number;
  /**
   * @min 0
   * @max 2147483647
   */
  lot?: number | null;
  /**
   * @min 0
   * @max 2147483647
   */
  rank?: number | null;
  position?: number | null;
}

export interface LiftsRequest {
  squat?: LiftAttemptRequest[];
  bench_press: LiftAttemptRequest[];
  deadlift?: LiftAttemptRequest[];
}

export interface ListAdmin {
  id: number;
  /** @maxLength 150 */
  first_name?: string;
  /** @maxLength 150 */
  last_name?: string;
  /** Email address */
  email?: string;
}

export interface ListCompetitionAdminsResponse {
  competition_admins: string[];
}

export interface LoginResponse {
  /** @format date-time */
  expiry: string;
  token: string;
  user: User;
}

export interface MakeFederationAdminRequestRequest {
  /**
   * @format email
   * @minLength 1
   */
  email: string;
  federation_admin: boolean;
}

export interface MakeFederationAdminResponse {
  status: string;
}

export interface MakeJudgeAdminRequestRequest {
  /**
   * @format email
   * @minLength 1
   */
  email: string;
  judge_admin: boolean;
}

export interface MakeJudgeAdminResponse {
  status: string;
}

export interface PLCompetition {
  id: number;
  /** @maxLength 100 */
  name: string;
  /** @format date */
  start_date?: string | null;
  /** @format date */
  end_date?: string | null;
  team_comp: boolean;
  divisions: PLCompetitionDivision[];
  registrations: PLRegistration[];
}

export interface PLCompetitionDivision {
  id: number;
  name: string;
  scoring_system: ScoringSystemEnum;
  teams: PLCompetitionDivisionTeam[];
}

export interface PLCompetitionDivisionTeam {
  id: number;
  name: string;
}

export interface PLCompetitionResultRequest {
  groups: GroupRequest[];
}

export interface PLRegistration {
  id: number;
  license: string;
  name: string;
  /** The weight class of the lifter */
  weight_class: WeightClassEnum | NullEnum | null;
  /** The age category of the lifter */
  category: PLAgeCategoriesEnum;
  /** Whether the lifter is equipped */
  equipped: boolean;
  /** The type of the lifter */
  type: PLRegistrationTypeEnum;
  /** The lifter gender */
  sex: PLRegistrationSexEnum;
  /** The lifters club name */
  team: string;
  is_reserve?: boolean;
  competition_team: PLRegistrationCompetitionTeam | null;
  /** @format double */
  nomination_result: number | null;
  /**
   * * `APPROVED` - Approved
   * * `WITHDRAWN` - Withdrawn
   * * `NOT_APPROVED` - Not Approved
   */
  state?: RegistrationStateEnum;
}

export interface PLRegistrationCompetitionTeam {
  id: number;
  name: string;
  division: PLRegistrationCompetitionTeamDivision;
}

export interface PLRegistrationCompetitionTeamDivision {
  id: number;
  name: string;
  scoring_system: ScoringSystemEnum;
}

export interface PaginatedClubList {
  /** @example 123 */
  count: number;
  /** @example 13 */
  page_count: number;
  /** @example 1 */
  page_current: number;
  /** @example 100 */
  page_size: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: Club[];
}

export interface PaginatedCompetitionDivisionList {
  /** @example 123 */
  count: number;
  /** @example 13 */
  page_count: number;
  /** @example 1 */
  page_current: number;
  /** @example 100 */
  page_size: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: CompetitionDivision[];
}

export interface PaginatedCompetitionListList {
  /** @example 123 */
  count: number;
  /** @example 13 */
  page_count: number;
  /** @example 1 */
  page_current: number;
  /** @example 100 */
  page_size: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: CompetitionList[];
}

export interface PaginatedCompetitionTeamList {
  /** @example 123 */
  count: number;
  /** @example 13 */
  page_count: number;
  /** @example 1 */
  page_current: number;
  /** @example 100 */
  page_size: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: CompetitionTeam[];
}

export interface PaginatedDistrictList {
  /** @example 123 */
  count: number;
  /** @example 13 */
  page_count: number;
  /** @example 1 */
  page_current: number;
  /** @example 100 */
  page_size: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: District[];
}

export interface PaginatedDivisionList {
  /** @example 123 */
  count: number;
  /** @example 13 */
  page_count: number;
  /** @example 1 */
  page_current: number;
  /** @example 100 */
  page_size: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: Division[];
}

export interface PaginatedGroupList {
  /** @example 123 */
  count: number;
  /** @example 13 */
  page_count: number;
  /** @example 1 */
  page_current: number;
  /** @example 100 */
  page_size: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: Group[];
}

export interface PaginatedJudgeDutyList {
  /** @example 123 */
  count: number;
  /** @example 13 */
  page_count: number;
  /** @example 1 */
  page_current: number;
  /** @example 100 */
  page_size: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: JudgeDuty[];
}

export interface PaginatedJudgeLicenseList {
  /** @example 123 */
  count: number;
  /** @example 13 */
  page_count: number;
  /** @example 1 */
  page_current: number;
  /** @example 100 */
  page_size: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: JudgeLicense[];
}

export interface PaginatedJudgeList {
  /** @example 123 */
  count: number;
  /** @example 13 */
  page_count: number;
  /** @example 1 */
  page_current: number;
  /** @example 100 */
  page_size: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: Judge[];
}

export interface PaginatedJudgeSerializerDetailedList {
  /** @example 123 */
  count: number;
  /** @example 13 */
  page_count: number;
  /** @example 1 */
  page_current: number;
  /** @example 100 */
  page_size: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: JudgeSerializerDetailed[];
}

export interface PaginatedLicenseList {
  /** @example 123 */
  count: number;
  /** @example 13 */
  page_count: number;
  /** @example 1 */
  page_current: number;
  /** @example 100 */
  page_size: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: License[];
}

export interface PaginatedPersonSerializerResponseList {
  /** @example 123 */
  count: number;
  /** @example 13 */
  page_count: number;
  /** @example 1 */
  page_current: number;
  /** @example 100 */
  page_size: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: PersonSerializerResponse[];
}

export interface PaginatedRegistrationCategoryList {
  /** @example 123 */
  count: number;
  /** @example 13 */
  page_count: number;
  /** @example 1 */
  page_current: number;
  /** @example 100 */
  page_size: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: RegistrationCategory[];
}

export interface PaginatedRegistrationList {
  /** @example 123 */
  count: number;
  /** @example 13 */
  page_count: number;
  /** @example 1 */
  page_current: number;
  /** @example 100 */
  page_size: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: Registration[];
}

export interface PaginatedResultList {
  /** @example 123 */
  count: number;
  /** @example 13 */
  page_count: number;
  /** @example 1 */
  page_current: number;
  /** @example 100 */
  page_size: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: Result[];
}

export interface PaginatedResultRankingList {
  /** @example 123 */
  count: number;
  /** @example 13 */
  page_count: number;
  /** @example 1 */
  page_current: number;
  /** @example 100 */
  page_size: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: ResultRanking[];
}

export interface PaginatedRoundList {
  /** @example 123 */
  count: number;
  /** @example 13 */
  page_count: number;
  /** @example 1 */
  page_current: number;
  /** @example 100 */
  page_size: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: Round[];
}

export interface PaginatedRoundResultList {
  /** @example 123 */
  count: number;
  /** @example 13 */
  page_count: number;
  /** @example 1 */
  page_current: number;
  /** @example 100 */
  page_size: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: RoundResult[];
}

export interface PaginatedSeriesList {
  /** @example 123 */
  count: number;
  /** @example 13 */
  page_count: number;
  /** @example 1 */
  page_current: number;
  /** @example 100 */
  page_size: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: Series[];
}

export interface PaginatedTeamList {
  /** @example 123 */
  count: number;
  /** @example 13 */
  page_count: number;
  /** @example 1 */
  page_current: number;
  /** @example 100 */
  page_size: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: Team[];
}

export interface PasswordChangeRequestRequest {
  /** @minLength 1 */
  old_password: string;
  /** @minLength 1 */
  new_password1: string;
  /** @minLength 1 */
  new_password2: string;
}

export interface PasswordChangeResponse {
  message: string;
}

export interface PasswordResetConfirmRequestRequest {
  /** @minLength 1 */
  token: string;
  /** @minLength 1 */
  new_password1: string;
  /** @minLength 1 */
  new_password2: string;
}

export interface PasswordResetConfirmResponse {
  message: string;
}

export interface PasswordResetRequestRequest {
  /**
   * @format email
   * @minLength 1
   */
  email: string;
  /** @minLength 1 */
  url: string;
}

export interface PasswordResetResponse {
  message: string;
}

export interface PatchedClubWriteRequest {
  /**
   * Name of club
   * @minLength 1
   * @maxLength 100
   */
  name?: string;
  /** E-mail of club */
  email?: string | null;
  /** Website of club */
  website?: string | null;
  district?: number | null;
  /** Flags if club is active */
  is_active?: boolean;
}

export interface PatchedCompetitionDivisionWriteRequest {
  competition?: number;
  /**
   * @minLength 1
   * @maxLength 100
   */
  name?: string;
  competition_type?: number;
  age_categories?: number[];
  /**
   * * `IPFGL` - IPFGL
   * * `IPFGL_MALE` - IPFGL Herr
   * * `IPF` - IPF
   * * `IPF_MALE` - IPF Herr
   * * `WILKS` - WILKS
   * * `WILKS_MALE` - WILKS Herr
   * * `DOTS` - DOTS
   * * `DOTS_MALE` - DOTS Herr
   */
  scoring_system?: ScoringSystemEnum;
  /** @format date */
  nomination_start_date?: string | null;
  /** @format date */
  nomination_end_date?: string | null;
  /**
   * * `M` - Herr
   * * `F` - Dam
   * * `B` - Blandat
   */
  gender?: GenderEnum;
  /**
   * @min 0
   * @max 32767
   */
  lifters_per_team?: number;
  /**
   * @min 0
   * @max 32767
   */
  reserve_slots?: number;
  /**
   * @min 0
   * @max 32767
   */
  min_female_lifters?: number;
  /**
   * @min 0
   * @max 32767
   */
  min_male_lifters?: number;
  source_series_division?: number | null;
}

export interface PatchedCompetitionRequest {
  /**
   * @minLength 1
   * @maxLength 100
   */
  name?: string;
  /** @format date */
  start_date?: string | null;
  /** @format date */
  end_date?: string | null;
  /**
   * * `WG` - World Games
   * * `VM` - VM
   * * `EM` - EM
   * * `NM` - NM
   * * `INT` - Internationell
   * * `SM` - SM
   * * `RM` - RM
   * * `LDM` - LDM
   * * `DM` - DM
   * * `GENERAL` - Serie/Övrig
   * * `KM` - KM
   */
  category?: CompetitionCategoryEnum;
  /**
   * * `CREATED` - Created
   * * `PUBLISHED` - Published
   * * `CLOSED` - Closed
   * * `ARCHIVED` - Archived
   */
  state?: CompetitionStateEnum;
  /** @format date-time */
  reg_deadline?: string | null;
  /** Specifies if the competition is open for external registrations */
  open_externally?: boolean;
  /** Marks whether this competition is team-based. */
  is_team_comp?: boolean;
  /**
   * Maximum number of registrations allowed when open_externally is true. NULL means no limit.
   * @min 0
   * @max 2147483647
   */
  registrations_limit?: number | null;
  /** Organizer name(s) */
  organizer?: string | null;
  /** Contact First Name */
  contact_first_name?: string | null;
  /** Contact Last Name */
  contact_last_name?: string | null;
  /** Contact Email */
  contact_email?: string | null;
  /**
   * Contact Phone
   * @maxLength 128
   */
  contact_phone?: string | null;
  /** Payment info/nr/account */
  payment_info?: string | null;
  /** Location (City or City Country) */
  location?: string | null;
  files?: string[];
  /** Districts the competition is associated with */
  districts?: number[];
}

export interface PatchedCompetitionTeamWriteRequest {
  division?: number;
  /**
   * @minLength 1
   * @maxLength 100
   */
  name?: string;
  club?: number | null;
}

export interface PatchedDistrictWriteRequest {
  /**
   * Full name of the district
   * @minLength 1
   * @maxLength 100
   */
  name?: string;
  /** @maxLength 11 */
  orgnr?: string | null;
  /**
   * @min 0
   * @max 99999
   */
  rfnr?: number | null;
  /** E-mail of District */
  email?: string | null;
  website?: string | null;
  region?: number | null;
}

export interface PatchedDivisionWriteRequest {
  series?: number;
  /** @minLength 1 */
  name?: string;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  results_per_round?: number;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  max_teams?: number;
  /**
   * @min 1
   * @max 2147483647
   */
  level?: number;
  rounds?: number[];
}

export interface PatchedGroupWriteRequest {
  competition?: number | null;
  /** @maxLength 50 */
  name?: string | null;
  /** @format date-time */
  start?: string;
}

export interface PatchedJudgeDutyWriteRequest {
  judge?: number;
  /**
   * * `HD` - Huvuddomare
   * * `SD` - Sidodomare
   * * `TK` - Teknisk Kontrollant
   * * `TL` - Tävlingsledare
   * * `JU` - Jury
   * * `SP` - Speaker
   * * `IN` - Instruktör
   */
  role?: RoleEnum;
  group?: number;
}

export interface PatchedJudgeLicenseWriteRequest {
  judge?: number;
  club?: number | null;
  /**
   * Issue date and start of validity
   * @format date
   */
  start_date?: string;
  /**
   * Date of license expiry
   * @format date
   */
  end_date?: string;
  /**
   * * `D` - Distriktsdomare
   * * `F` - Förbundsdomare
   * * `K2` - Kat 2. Domare
   * * `K1` - Kat 1. Domare
   */
  level?: RecentLevelParaEnum;
  is_para?: boolean;
}

export interface PatchedJudgeWriteRequest {
  /**
   * @min 0
   * @max 2147483647
   */
  book?: number | null;
  /**
   * * `active` - Aktiv
   * * `warned` - Varnad
   * * `suspended` - Avstängd
   * * `unknown` - Okänd
   */
  status?: JudgeStatusEnum;
  person?: number;
}

export interface PatchedLicenseWriteRequest {
  person?: number;
  club?: number;
  /**
   * Issue date and start of validity
   * @format date
   */
  start_date?: string;
  /**
   * Date of license expiry
   * @format date
   */
  end_date?: string;
}

export interface PatchedPersonRequest {
  /**
   * @minLength 1
   * @maxLength 50
   */
  first_name?: string;
  /**
   * @minLength 1
   * @maxLength 50
   */
  last_name?: string;
  /** @minLength 1 */
  ssn?: string;
  is_para?: boolean;
  is_ifn?: boolean;
  /** The club the lifter belongs to and is administrated by */
  club?: number | null;
}

export interface PatchedRegistrationCategoryWriteRequest {
  competition?: number;
  competition_type?: number;
  age_category?: number;
  weight_class?: number | null;
  /**
   * Start date from which the qualifier is calculated
   * @format date
   */
  start_date?: string | null;
  /**
   * End date until which qualifiers are calculated
   * @format date
   */
  end_date?: string | null;
  /**
   * @format double
   * @min -10000
   * @exclusiveMin true
   * @max 10000
   * @exclusiveMax true
   */
  limit?: number | null;
}

export interface PatchedRegistrationWriteRequest {
  competition?: number;
  person?: number;
  team?: number | null;
  competition_type?: number;
  age_category?: number | null;
  weight_class?: number | null;
  is_reserve?: boolean;
  is_approved?: boolean;
  /**
   * * `APPROVED` - Approved
   * * `WITHDRAWN` - Withdrawn
   * * `NOT_APPROVED` - Not Approved
   */
  state?: RegistrationStateEnum;
}

export interface PatchedResultWriteRequest {
  group?: number;
  person?: number;
  team?: number | null;
  competition_type?: number | null;
  age_category?: number | null;
  /**
   * @format double
   * @min -1000
   * @exclusiveMin true
   * @max 1000
   * @exclusiveMax true
   */
  body_weight?: number;
  /**
   * @format double
   * @min -10000
   * @exclusiveMin true
   * @max 10000
   * @exclusiveMax true
   */
  squat?: number;
  /**
   * @format double
   * @min -10000
   * @exclusiveMin true
   * @max 10000
   * @exclusiveMax true
   */
  benchpress?: number;
  /**
   * @format double
   * @min -10000
   * @exclusiveMin true
   * @max 10000
   * @exclusiveMax true
   */
  deadlift?: number;
  /** Marks if a result is considered to be part of a coefficient group/sub-group */
  is_coef_group?: boolean;
  /** Marks if the result is disqualified */
  disqualified?: boolean;
  /**
   * @min 0
   * @max 2147483647
   */
  lot?: number | null;
  /**
   * @min 0
   * @max 2147483647
   */
  rank?: number | null;
  /**
   * Controls whether this result should be included in or excluded from records
   *
   * * `default` - Default
   * * `exclude` - Exclude
   * * `include` - Include
   */
  national_record_status?: RecordStatusEnum;
  /**
   * Controls whether this result should be included in or excluded from records
   *
   * * `default` - Default
   * * `exclude` - Exclude
   * * `include` - Include
   */
  district_record_status?: RecordStatusEnum;
  /**
   * Number of good lifts in total (all disciplines). Used for calculating U11-13 points.
   * @min 0
   * @max 9
   */
  good_lifts?: number;
  /**
   * Number of good lifts in benchpres. Used for calculating U11-13 points.
   * @min 0
   * @max 3
   */
  good_lifts_bp?: number;
}

export interface PatchedRoundRequest {
  name?: string | null;
  /** @format date */
  start?: string;
  /** @format date */
  end?: string;
}

export interface PatchedRoundResultWriteRequest {
  team?: number;
  round?: number;
}

export interface PatchedSeriesWriteRequest {
  /** @minLength 1 */
  name?: string;
  /**
   * @min 0
   * @max 2147483647
   */
  year?: number;
  competition_type?: number;
  /**
   * * `M` - Herr
   * * `F` - Dam
   * * `B` - Blandat
   */
  gender?: GenderEnum;
  age_categories?: number[];
  /**
   * * `IPFGL` - IPFGL
   * * `IPFGL_MALE` - IPFGL Herr
   * * `IPF` - IPF
   * * `IPF_MALE` - IPF Herr
   * * `WILKS` - WILKS
   * * `WILKS_MALE` - WILKS Herr
   * * `DOTS` - DOTS
   * * `DOTS_MALE` - DOTS Herr
   */
  scoring_system?: ScoringSystemEnum;
}

export interface PatchedStandardRecordRequest {
  /** @format date */
  date?: string;
  district?: number | null;
  competition_type?: number;
  age_category?: number;
  weight_class?: number;
  /**
   * * `sq` - Knäböj
   * * `bp` - Bänkpress
   * * `dl` - Marklyft
   * * `total` - Sammanlagt
   */
  discipline?: DisciplineEnum;
  /**
   * @format double
   * @min -10000
   * @exclusiveMin true
   * @max 10000
   * @exclusiveMax true
   */
  result?: number;
}

export interface PatchedTeamWriteRequest {
  division?: number;
  /** @minLength 1 */
  name?: string;
  club?: number;
}

export interface PatchedUserRequest {
  /** @maxLength 150 */
  first_name?: string;
  /** @maxLength 150 */
  last_name?: string;
  /**
   * Required. 150 characters or fewer. Letters, digits and @/./+/-/_ only.
   * @minLength 1
   * @maxLength 150
   * @pattern ^[\w.@+-]+$
   */
  username?: string;
  /** Email address */
  email?: string;
}

export interface Permission {
  federation_admin?: boolean;
  judge_admin?: boolean;
  clubs_admin: ClubSerializerSmall[];
  districts_admin: DistrictSerializerSmall[];
  competitions_admin: CompetitionSerializerSmall[];
}

export interface PermissionRequest {
  federation_admin?: boolean;
  judge_admin?: boolean;
}

export interface PersonClubDistrict {
  id: number;
  /** License id for the person */
  license_id: string | null;
  first_name: string;
  last_name: string;
  club: ClubDistrict;
  /** Gender flag, true if male, false if female */
  is_male: boolean;
}

export interface PersonLicense {
  id: number;
  club: ClubSerializerSmall;
  /**
   * Issue date and start of validity
   * @format date
   */
  start_date: string;
  /**
   * Date of license expiry
   * @format date
   */
  end_date: string;
  license_id: string;
}

export interface PersonRequest {
  /**
   * @minLength 1
   * @maxLength 50
   */
  first_name: string;
  /**
   * @minLength 1
   * @maxLength 50
   */
  last_name: string;
  /** @minLength 1 */
  ssn: string;
  is_para?: boolean;
  is_ifn?: boolean;
  /** The club the lifter belongs to and is administrated by */
  club?: number | null;
}

export interface PersonResult {
  id: number;
  /** @maxLength 50 */
  first_name: string;
  /** @maxLength 50 */
  last_name: string;
  /**
   * Person date of birth
   * @format date
   */
  birthdate?: string | null;
  /** Gender flag, true if male, false if female */
  is_male?: boolean;
  /**
   * License id for the person
   * @maxLength 20
   */
  license_id?: string | null;
}

export interface PersonSerializerDetailed {
  id: number;
  /** @maxLength 50 */
  first_name: string;
  /** @maxLength 50 */
  last_name: string;
  /**
   * Person date of birth
   * @format date
   */
  birthdate: string | null;
  /** License id for the person */
  license_id: string | null;
  /**
   * Swedish Social-security number (personnummer)
   * @maxLength 12
   */
  ssn?: string | null;
  /** Flag of whether a SSN is valid. The old Database does not validate this */
  ssn_is_valid: boolean | null;
  is_para?: boolean;
  is_ifn?: boolean;
  /** Gender flag, true if male, false if female */
  is_male: boolean;
  club: ClubDistrict;
  licenses: PersonLicense[];
  judge: Judge;
  results: LifterResult[];
  personal_bests: PersonalBestEntry[];
}

export interface PersonSerializerResponse {
  id: number;
  /** @maxLength 50 */
  first_name: string;
  /** @maxLength 50 */
  last_name: string;
  /**
   * Person date of birth
   * @format date
   */
  birthdate: string | null;
  /** License id for the person */
  license_id: string | null;
  /**
   * Swedish Social-security number (personnummer)
   * @maxLength 12
   */
  ssn?: string | null;
  /** Flag of whether a SSN is valid. The old Database does not validate this */
  ssn_is_valid: boolean | null;
  is_para?: boolean;
  is_ifn?: boolean;
  /** Gender flag, true if male, false if female */
  is_male: boolean;
  club: ClubDistrict;
  is_licensed: boolean;
  latest_license_year: number | null;
  /** Server-computed field included only when can_register_for_competition is supplied. */
  can_register?: boolean | null;
}

export interface PersonSerializerSmall {
  id: number;
  /** @maxLength 50 */
  first_name: string;
  /** @maxLength 50 */
  last_name: string;
  /**
   * License id for the person
   * @maxLength 20
   */
  license_id?: string | null;
  /** Gender flag, true if male, false if female */
  is_male?: boolean;
}

export interface PersonalBestEntry {
  competition_type: CompetitionType;
  squat?: LiftResult;
  benchpress?: LiftResult;
  deadlift?: LiftResult;
  total?: LiftResult;
  points?: LiftResult;
}

export interface Point {
  /**
   * @format double
   * @min -10000
   * @exclusiveMin true
   * @max 10000
   * @exclusiveMax true
   */
  ipfgl?: number | null;
  /**
   * @format double
   * @min -10000
   * @exclusiveMin true
   * @max 10000
   * @exclusiveMax true
   */
  ipfglbp?: number | null;
  /**
   * @format double
   * @min -1000000
   * @exclusiveMin true
   * @max 1000000
   * @exclusiveMax true
   */
  ipf?: number | null;
  /**
   * @format double
   * @min -1000000
   * @exclusiveMin true
   * @max 1000000
   * @exclusiveMax true
   */
  ipfbp?: number | null;
  /**
   * @format double
   * @min -10000
   * @exclusiveMin true
   * @max 10000
   * @exclusiveMax true
   */
  wilks?: number | null;
  /**
   * @format double
   * @min -10000
   * @exclusiveMin true
   * @max 10000
   * @exclusiveMax true
   */
  wilksbp?: number | null;
  /**
   * @format double
   * @min -10000
   * @exclusiveMin true
   * @max 10000
   * @exclusiveMax true
   */
  dots?: number | null;
  /**
   * @format double
   * @min -10000
   * @exclusiveMin true
   * @max 10000
   * @exclusiveMax true
   */
  dotsbp?: number | null;
  /**
   * @format double
   * @min -1000000
   * @exclusiveMin true
   * @max 1000000
   * @exclusiveMax true
   */
  u11_13?: number | null;
  /**
   * @format double
   * @min -1000000
   * @exclusiveMin true
   * @max 1000000
   * @exclusiveMax true
   */
  u11_13bp?: number | null;
  /**
   * @format double
   * @min -10000
   * @exclusiveMin true
   * @max 10000
   * @exclusiveMax true
   */
  para?: number | null;
}

export interface PointsType {
  name: string;
  description: string;
}

export interface RankingDisicipline {
  /** Name/Value of the disicipline */
  name: string;
  /** Display label of the disicipline */
  label: string;
  /** List of sub-types of the disicipline (e.g. different points systems) */
  sub_types: string[];
}

export interface RecordEntity {
  id: number;
  competition: CompetitionSerializerSmall | null;
  person: PersonSerializerSmall | null;
  club: ClubDistrict | null;
  /** @format date-time */
  date: string;
  weight_class: WeightClassResult;
  /**
   * @format double
   * @min -1000
   * @exclusiveMin true
   * @max 1000
   * @exclusiveMax true
   */
  body_weight: number | null;
  /** @format double */
  result: number;
}

export interface RecordCompetitionType {
  /** ID of the competition type. */
  id: number;
  /** Name of the competition type. */
  name: string;
  /** Display extended name of the competition type. */
  description: string;
  age_category: AgeCategorySerializerSmall;
  /** List of records for this competition type grouped by discipline */
  records: RecordDiscipline[];
}

export interface RecordDiscipline {
  /** Name/Value of the disicipline */
  name: string;
  /** Display label of the disicipline */
  label: string;
  /** List of records for this discipline */
  records: RecordEntity[];
}

export interface RefereeRequest {
  /** @minLength 1 */
  license: string;
  /** @minLength 1 */
  name?: string;
  /**
   * * `chief_referee` - chief_referee
   * * `side_referee` - side_referee
   * * `jury` - jury
   * * `speaker` - speaker
   * * `technical_controller` - technical_controller
   * * `meet_director` - meet_director
   */
  assignment: AssignmentEnum;
}

export interface Region {
  id: number;
  /** @maxLength 50 */
  name: string;
}

export interface RegisterRequestRequest {
  /** @minLength 1 */
  username: string;
  /**
   * @format email
   * @minLength 1
   */
  email: string;
  /** @minLength 1 */
  password1: string;
  /** @minLength 1 */
  password2: string;
  /** @minLength 1 */
  first_name: string;
  /** @minLength 1 */
  last_name: string;
  /** @minLength 1 */
  url: string;
}

export interface RegisterResponse {
  message: string;
}

export interface Registration {
  id: number;
  competition: CompetitionSerializerSmall;
  team: CompetitionTeam;
  division: CompetitionDivisionSerializerSmall;
  person: PersonClubDistrict;
  license: PersonLicense;
  competition_type: CompetitionType;
  age_category: AgeCategorySerializerSmall;
  weight_class: WeightClassResult | null;
  is_reserve?: boolean;
  is_qualified: boolean;
  nomination_result: number;
  is_approved?: boolean;
  /**
   * * `APPROVED` - Approved
   * * `WITHDRAWN` - Withdrawn
   * * `NOT_APPROVED` - Not Approved
   */
  state?: RegistrationStateEnum;
  /** @format uuid */
  registration_uid: string | null;
  /** @format date-time */
  valid_from: string | null;
  /** @format date-time */
  valid_to: string | null;
  action: string | null;
  is_deleted: boolean | null;
  changed_by: ChangedBy | null;
}

export interface RegistrationCategoriesSummaryAgeCategory {
  age_category: AgeCategorySerializerSmall;
  weight_classes: WeightClassResult[];
}

export interface RegistrationCategoriesSummaryResponse {
  competition_type: CompetitionType;
  age_categories: RegistrationCategoriesSummaryAgeCategory[];
}

export interface RegistrationCategory {
  id: number;
  competition: CompetitionSerializerSmall;
  competition_type: CompetitionType;
  age_category: AgeCategorySerializerSmall;
  weight_class: WeightClassResult | null;
  /**
   * Start date from which the qualifier is calculated
   * @format date
   */
  start_date?: string | null;
  /**
   * End date until which qualifiers are calculated
   * @format date
   */
  end_date?: string | null;
  /**
   * @format double
   * @min -10000
   * @exclusiveMin true
   * @max 10000
   * @exclusiveMax true
   */
  limit?: number | null;
}

export interface RegistrationCategoryBulkWriteRequest {
  competition_type: number;
  age_category: number;
  weight_class?: number | null;
  /**
   * Start date from which the qualifier is calculated
   * @format date
   */
  start_date?: string | null;
  /**
   * End date until which qualifiers are calculated
   * @format date
   */
  end_date?: string | null;
  /**
   * @format double
   * @min -10000
   * @exclusiveMin true
   * @max 10000
   * @exclusiveMax true
   */
  limit?: number | null;
}

export interface RegistrationCategoryWriteRequest {
  competition: number;
  competition_type: number;
  age_category: number;
  weight_class?: number | null;
  /**
   * Start date from which the qualifier is calculated
   * @format date
   */
  start_date?: string | null;
  /**
   * End date until which qualifiers are calculated
   * @format date
   */
  end_date?: string | null;
  /**
   * @format double
   * @min -10000
   * @exclusiveMin true
   * @max 10000
   * @exclusiveMax true
   */
  limit?: number | null;
}

export interface RegistrationWriteRequest {
  competition: number;
  person: number;
  team?: number | null;
  competition_type?: number;
  age_category?: number | null;
  weight_class?: number | null;
  is_reserve?: boolean;
  is_approved?: boolean;
  /**
   * * `APPROVED` - Approved
   * * `WITHDRAWN` - Withdrawn
   * * `NOT_APPROVED` - Not Approved
   */
  state?: RegistrationStateEnum;
}

export interface RemoveClubAdminRequestRequest {
  /**
   * @format email
   * @minLength 1
   */
  email: string;
}

export interface RemoveClubAdminResponse {
  status: string;
}

export interface RemoveCompetitionAdminRequestRequest {
  /**
   * @format email
   * @minLength 1
   */
  email: string;
}

export interface RemoveCompetitionAdminResponse {
  status: string;
}

export interface RemoveDistrictAdminRequestRequest {
  /**
   * @format email
   * @minLength 1
   */
  email: string;
}

export interface RemoveDistrictAdminResponse {
  status: string;
}

export interface Result {
  id: number;
  group: Group;
  person: PersonSerializerSmall;
  club: ClubDistrict;
  team: CompetitionTeam;
  division: CompetitionDivisionSerializerSmall;
  competition_type: CompetitionType;
  age_category: AgeCategorySerializerSmall;
  weight_class: WeightClassResult;
  /**
   * @format double
   * @min -1000
   * @exclusiveMin true
   * @max 1000
   * @exclusiveMax true
   */
  body_weight: number;
  /**
   * @format double
   * @min -10000
   * @exclusiveMin true
   * @max 10000
   * @exclusiveMax true
   */
  squat: number | null;
  /**
   * @format double
   * @min -10000
   * @exclusiveMin true
   * @max 10000
   * @exclusiveMax true
   */
  benchpress: number | null;
  /**
   * @format double
   * @min -10000
   * @exclusiveMin true
   * @max 10000
   * @exclusiveMax true
   */
  deadlift: number | null;
  /**
   * @format double
   * @min -10000
   * @exclusiveMin true
   * @max 10000
   * @exclusiveMax true
   */
  total: number;
  points: Point;
  /** Marks if a result is considered to be part of a coefficient group/sub-group */
  is_coef_group?: boolean;
  /** Marks if the result is disqualified */
  disqualified?: boolean;
  /**
   * @min 0
   * @max 2147483647
   */
  lot?: number | null;
  /**
   * @min 0
   * @max 2147483647
   */
  rank?: number | null;
  /**
   * Controls whether this result should be included in or excluded from records
   *
   * * `default` - Default
   * * `exclude` - Exclude
   * * `include` - Include
   */
  national_record_status?: RecordStatusEnum;
  /**
   * Controls whether this result should be included in or excluded from records
   *
   * * `default` - Default
   * * `exclude` - Exclude
   * * `include` - Include
   */
  district_record_status?: RecordStatusEnum;
}

export interface ResultFailed {
  license: string;
  group: string;
  reason: string;
}

export interface ResultRanking {
  id: number;
  group: Group;
  person: PersonSerializerSmall;
  club: ClubDistrict;
  competition_type: CompetitionType;
  age_category: AgeCategorySerializerSmall;
  weight_class: WeightClassResult;
  /**
   * @format double
   * @min -1000
   * @exclusiveMin true
   * @max 1000
   * @exclusiveMax true
   */
  body_weight: number;
  /**
   * @format double
   * @min -10000
   * @exclusiveMin true
   * @max 10000
   * @exclusiveMax true
   */
  squat: number | null;
  /**
   * @format double
   * @min -10000
   * @exclusiveMin true
   * @max 10000
   * @exclusiveMax true
   */
  benchpress: number | null;
  /**
   * @format double
   * @min -10000
   * @exclusiveMin true
   * @max 10000
   * @exclusiveMax true
   */
  deadlift: number | null;
  /** @format double */
  result: number;
  /**
   * @format double
   * @min -10000
   * @exclusiveMin true
   * @max 10000
   * @exclusiveMax true
   */
  total: number;
  points: Point;
  rank_nr: number;
  /**
   * @min 0
   * @max 2147483647
   */
  lot?: number | null;
  /**
   * @min 0
   * @max 2147483647
   */
  rank?: number | null;
}

export interface ResultRequest {
  lifter: LifterRequest;
  lifts: LiftsRequest;
}

export interface ResultSuccess {
  status: string;
  failed_results: ResultFailed[];
  nr_saved_results: number;
  failed_referees: ResultFailed[];
  nr_saved_referees: number;
}

export interface ResultWrite {
  id: number;
  group: number;
  person: number;
  team?: number | null;
  competition_type?: number | null;
  age_category?: number | null;
  /**
   * @format double
   * @min -1000
   * @exclusiveMin true
   * @max 1000
   * @exclusiveMax true
   */
  body_weight: number;
  /**
   * @format double
   * @min -10000
   * @exclusiveMin true
   * @max 10000
   * @exclusiveMax true
   */
  squat?: number;
  /**
   * @format double
   * @min -10000
   * @exclusiveMin true
   * @max 10000
   * @exclusiveMax true
   */
  benchpress?: number;
  /**
   * @format double
   * @min -10000
   * @exclusiveMin true
   * @max 10000
   * @exclusiveMax true
   */
  deadlift?: number;
  /** Marks if a result is considered to be part of a coefficient group/sub-group */
  is_coef_group?: boolean;
  /** Marks if the result is disqualified */
  disqualified?: boolean;
  /**
   * @min 0
   * @max 2147483647
   */
  lot?: number | null;
  /**
   * @min 0
   * @max 2147483647
   */
  rank?: number | null;
  /**
   * Controls whether this result should be included in or excluded from records
   *
   * * `default` - Default
   * * `exclude` - Exclude
   * * `include` - Include
   */
  national_record_status?: RecordStatusEnum;
  /**
   * Controls whether this result should be included in or excluded from records
   *
   * * `default` - Default
   * * `exclude` - Exclude
   * * `include` - Include
   */
  district_record_status?: RecordStatusEnum;
  /**
   * Number of good lifts in total (all disciplines). Used for calculating U11-13 points.
   * @min 0
   * @max 9
   */
  good_lifts?: number;
  /**
   * Number of good lifts in benchpres. Used for calculating U11-13 points.
   * @min 0
   * @max 3
   */
  good_lifts_bp?: number;
}

export interface ResultWriteRequest {
  group: number;
  person: number;
  team?: number | null;
  competition_type?: number | null;
  age_category?: number | null;
  /**
   * @format double
   * @min -1000
   * @exclusiveMin true
   * @max 1000
   * @exclusiveMax true
   */
  body_weight: number;
  /**
   * @format double
   * @min -10000
   * @exclusiveMin true
   * @max 10000
   * @exclusiveMax true
   */
  squat?: number;
  /**
   * @format double
   * @min -10000
   * @exclusiveMin true
   * @max 10000
   * @exclusiveMax true
   */
  benchpress?: number;
  /**
   * @format double
   * @min -10000
   * @exclusiveMin true
   * @max 10000
   * @exclusiveMax true
   */
  deadlift?: number;
  /** Marks if a result is considered to be part of a coefficient group/sub-group */
  is_coef_group?: boolean;
  /** Marks if the result is disqualified */
  disqualified?: boolean;
  /**
   * @min 0
   * @max 2147483647
   */
  lot?: number | null;
  /**
   * @min 0
   * @max 2147483647
   */
  rank?: number | null;
  /**
   * Controls whether this result should be included in or excluded from records
   *
   * * `default` - Default
   * * `exclude` - Exclude
   * * `include` - Include
   */
  national_record_status?: RecordStatusEnum;
  /**
   * Controls whether this result should be included in or excluded from records
   *
   * * `default` - Default
   * * `exclude` - Exclude
   * * `include` - Include
   */
  district_record_status?: RecordStatusEnum;
  /**
   * Number of good lifts in total (all disciplines). Used for calculating U11-13 points.
   * @min 0
   * @max 9
   */
  good_lifts?: number;
  /**
   * Number of good lifts in benchpres. Used for calculating U11-13 points.
   * @min 0
   * @max 3
   */
  good_lifts_bp?: number;
}

export interface Round {
  id: number;
  name?: string | null;
  /** @format date */
  start: string;
  /** @format date */
  end: string;
}

export interface RoundRequest {
  name?: string | null;
  /** @format date */
  start: string;
  /** @format date */
  end: string;
}

export interface RoundResult {
  id: number;
  team: Team;
  round: Round;
  results: CompetitionResult[];
  /** @format double */
  points: number;
}

export interface RoundResultModifyResultRequest {
  results: number[];
}

export interface RoundResultWriteRequest {
  team: number;
  round: number;
}

export interface Series {
  id: number;
  name: string;
  /**
   * @min 0
   * @max 2147483647
   */
  year: number;
  competition_type: CompetitionType;
  /**
   * * `M` - Herr
   * * `F` - Dam
   * * `B` - Blandat
   */
  gender: GenderEnum;
  age_categories: AgeCategorySerializerSmall[];
  /**
   * * `IPFGL` - IPFGL
   * * `IPFGL_MALE` - IPFGL Herr
   * * `IPF` - IPF
   * * `IPF_MALE` - IPF Herr
   * * `WILKS` - WILKS
   * * `WILKS_MALE` - WILKS Herr
   * * `DOTS` - DOTS
   * * `DOTS_MALE` - DOTS Herr
   */
  scoring_system: ScoringSystemEnum;
}

export interface SeriesDetailed {
  id: number;
  name: string;
  /**
   * @min 0
   * @max 2147483647
   */
  year: number;
  competition_type: CompetitionType;
  /**
   * * `M` - Herr
   * * `F` - Dam
   * * `B` - Blandat
   */
  gender: GenderEnum;
  age_categories: AgeCategorySerializerSmall[];
  /**
   * * `IPFGL` - IPFGL
   * * `IPFGL_MALE` - IPFGL Herr
   * * `IPF` - IPF
   * * `IPF_MALE` - IPF Herr
   * * `WILKS` - WILKS
   * * `WILKS_MALE` - WILKS Herr
   * * `DOTS` - DOTS
   * * `DOTS_MALE` - DOTS Herr
   */
  scoring_system: ScoringSystemEnum;
  divisions: Division[];
}

export interface SeriesSerializerSmall {
  id: number;
  name: string;
  /**
   * @min 0
   * @max 2147483647
   */
  year: number;
  competition_type: CompetitionType;
}

export interface SeriesWriteRequest {
  /** @minLength 1 */
  name: string;
  /**
   * @min 0
   * @max 2147483647
   */
  year: number;
  competition_type: number;
  /**
   * * `M` - Herr
   * * `F` - Dam
   * * `B` - Blandat
   */
  gender?: GenderEnum;
  age_categories: number[];
  /**
   * * `IPFGL` - IPFGL
   * * `IPFGL_MALE` - IPFGL Herr
   * * `IPF` - IPF
   * * `IPF_MALE` - IPF Herr
   * * `WILKS` - WILKS
   * * `WILKS_MALE` - WILKS Herr
   * * `DOTS` - DOTS
   * * `DOTS_MALE` - DOTS Herr
   */
  scoring_system: ScoringSystemEnum;
}

export interface SourceSeriesDivision {
  id: number;
  name: string;
}

export interface StandardRecord {
  id: number;
  /** @format date */
  date: string;
  district: DistrictSerializerSmall | null;
  competition_type: CompetitionType;
  age_category: AgeCategorySerializerSmall;
  weight_class: WeightClassResult;
  /**
   * * `sq` - Knäböj
   * * `bp` - Bänkpress
   * * `dl` - Marklyft
   * * `total` - Sammanlagt
   */
  discipline: DisciplineEnum;
  /**
   * @format double
   * @min -10000
   * @exclusiveMin true
   * @max 10000
   * @exclusiveMax true
   */
  result: number;
}

export interface StandardRecordDiscipline {
  name: string;
  description: string;
}

export interface StandardRecordRequest {
  /** @format date */
  date: string;
  district: number | null;
  competition_type: number;
  age_category: number;
  weight_class: number;
  /**
   * * `sq` - Knäböj
   * * `bp` - Bänkpress
   * * `dl` - Marklyft
   * * `total` - Sammanlagt
   */
  discipline: DisciplineEnum;
  /**
   * @format double
   * @min -10000
   * @exclusiveMin true
   * @max 10000
   * @exclusiveMax true
   */
  result: number;
}

export interface Team {
  id: number;
  division: DivisionSerializerSmall;
  name: string;
  club: ClubDistrict;
  /** @format double */
  points: number;
}

export interface TeamDetailed {
  id: number;
  division: DivisionSerializerSmall;
  name: string;
  club: ClubDistrict;
  round_results: TeamRoundResultDetailed[];
}

export interface TeamRoundResultDetailed {
  id: number;
  round: Round;
  results: CompetitionResult[];
  /** @format double */
  points: number;
}

export interface TeamWrite {
  id: number;
  division: number;
  name: string;
  club: number;
}

export interface TeamWriteRequest {
  division: number;
  /** @minLength 1 */
  name: string;
  club: number;
}

export interface TokenValidationResponse {
  /** @default "Token is valid" */
  detail?: string;
}

export interface User {
  id: number;
  /** @maxLength 150 */
  first_name?: string;
  /** @maxLength 150 */
  last_name?: string;
  /**
   * Required. 150 characters or fewer. Letters, digits and @/./+/-/_ only.
   * @maxLength 150
   * @pattern ^[\w.@+-]+$
   */
  username: string;
  /** Email address */
  email?: string;
  permissions: Permission;
}

export interface UserRequest {
  /** @maxLength 150 */
  first_name?: string;
  /** @maxLength 150 */
  last_name?: string;
  /**
   * Required. 150 characters or fewer. Letters, digits and @/./+/-/_ only.
   * @minLength 1
   * @maxLength 150
   * @pattern ^[\w.@+-]+$
   */
  username: string;
  /** Email address */
  email?: string;
}

export interface VerifyEmailRequestRequest {
  /** @minLength 1 */
  token: string;
}

export interface VerifyEmailResponse {
  message: string;
}

export interface WeightClass {
  id: number;
  /**
   * @format double
   * @min -1000
   * @exclusiveMin true
   * @max 1000
   * @exclusiveMax true
   */
  min_weight: number;
  /**
   * @format double
   * @min -1000
   * @exclusiveMin true
   * @max 1000
   * @exclusiveMax true
   */
  max_weight: number;
  /** @default true */
  is_male?: boolean;
  /** @format date */
  valid_from?: string | null;
  /** @format date */
  valid_until?: string | null;
  active: boolean;
  competition_types: CompetitionTypeWC[];
  age_categories: AgeCategorySerializerSmall[];
}

export interface WeightClassResult {
  id: number;
  name: string;
  is_male?: boolean;
}

export interface YearListResponse {
  years: number[];
}

import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType,
} from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export type ContentType =
  | "application/json"
  | "application/vnd.api+json"
  | "multipart/form-data"
  | "application/x-www-form-urlencoded"
  | "text/plain";

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || "",
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig,
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[
            method.toLowerCase() as keyof HeadersDefaults
          ]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] =
        property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(
          key,
          isFileType ? formItem : this.stringifyFormItem(formItem),
        );
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (
      type === "multipart/form-data" &&
      body &&
      body !== null &&
      typeof body === "object"
    ) {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (
      type === "text/plain" &&
      body &&
      body !== null &&
      typeof body !== "string"
    ) {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title SSF API
 * @version 0.0.1
 *
 * API for managment of the Swedish Powerlifting Federation
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * @description Retrieve a list of age categories.
     *
     * @tags age_categories
     * @name AgeCategoriesList
     * @summary List age categories
     * @request GET:/api/age_categories
     * @secure
     */
    ageCategoriesList: (
      query?: {
        age?: number;
        competition_type_name?: string;
        competition_types?: number[];
        /** @format date */
        date?: string;
        has_records?: boolean;
        is_archived?: boolean;
        max_age?: number;
        min_age?: number;
        /** Which field to use when ordering the results. */
        ordering?: string;
        person?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<AgeCategory[], any>({
        path: `/api/age_categories`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve an age category by ID.
     *
     * @tags age_categories
     * @name AgeCategoriesRetrieve
     * @summary Retrieve an age category
     * @request GET:/api/age_categories/{id}
     * @secure
     */
    ageCategoriesRetrieve: (id: number, params: RequestParams = {}) =>
      this.request<AgeCategory, any>({
        path: `/api/age_categories/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Verify the user's email address using the provided token.
     *
     * @tags auth
     * @name AuthEmailVerifyCreate
     * @request POST:/api/auth/email-verify/
     * @secure
     */
    authEmailVerifyCreate: (
      data: VerifyEmailRequestRequest,
      params: RequestParams = {},
    ) =>
      this.request<VerifyEmailResponse, void>({
        path: `/api/auth/email-verify/`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to validate the token and check if the user is logged in.
     *
     * @tags auth
     * @name AuthLoggedinCreate
     * @request POST:/api/auth/loggedin/
     * @secure
     */
    authLoggedinCreate: (params: RequestParams = {}) =>
      this.request<TokenValidationResponse, void>({
        path: `/api/auth/loggedin/`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Login endpoint that returns a token along with the authenticated user details.
     *
     * @tags auth
     * @name AuthLoginCreate
     * @request POST:/api/auth/login/
     * @secure
     */
    authLoginCreate: (data: AuthTokenRequest, params: RequestParams = {}) =>
      this.request<LoginResponse, void>({
        path: `/api/auth/login/`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * @description Logout endpoint that invalidates the current token.
     *
     * @tags auth
     * @name AuthLogoutCreate
     * @request POST:/api/auth/logout/
     * @secure
     */
    authLogoutCreate: (params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/auth/logout/`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * @description Logout from all sessions, invalidates all tokens associated with the user.
     *
     * @tags auth
     * @name AuthLogoutallCreate
     * @request POST:/api/auth/logoutall/
     * @secure
     */
    authLogoutallCreate: (params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/auth/logoutall/`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * @description Change the user's password.
     *
     * @tags auth
     * @name AuthPasswordChangeCreate
     * @request POST:/api/auth/password-change/
     * @secure
     */
    authPasswordChangeCreate: (
      data: PasswordChangeRequestRequest,
      params: RequestParams = {},
    ) =>
      this.request<PasswordChangeResponse, void>({
        path: `/api/auth/password-change/`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * @description Request a password reset email.
     *
     * @tags auth
     * @name AuthPasswordResetCreate
     * @request POST:/api/auth/password-reset/
     * @secure
     */
    authPasswordResetCreate: (
      data: PasswordResetRequestRequest,
      params: RequestParams = {},
    ) =>
      this.request<PasswordResetResponse, void>({
        path: `/api/auth/password-reset/`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * @description Confirm the password reset using the provided token and set a new password.
     *
     * @tags auth
     * @name AuthPasswordResetConfirmCreate
     * @request POST:/api/auth/password-reset-confirm/
     * @secure
     */
    authPasswordResetConfirmCreate: (
      data: PasswordResetConfirmRequestRequest,
      params: RequestParams = {},
    ) =>
      this.request<PasswordResetConfirmResponse, void>({
        path: `/api/auth/password-reset-confirm/`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * @description Register a new user and send a verification email.
     *
     * @tags auth
     * @name AuthRegisterCreate
     * @request POST:/api/auth/register/
     * @secure
     */
    authRegisterCreate: (
      data: RegisterRequestRequest,
      params: RequestParams = {},
    ) =>
      this.request<RegisterResponse, void>({
        path: `/api/auth/register/`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * @description Get a summary of invoicable items for clubs. These include license fees, judge license fees, and team fees (series).
     *
     * @tags club_invoicable
     * @name ClubInvoicableRetrieve
     * @summary Get a summary of invoicable items for clubs.
     * @request GET:/api/club_invoicable
     * @secure
     */
    clubInvoicableRetrieve: (
      query: {
        /**
         * End date of the invoicable period. Format: YYYY-MM-DD.
         * @format date
         */
        end_date: string;
        /** Format of the response. Default is xlsx. */
        format?: "xlsx";
        /**
         * Start date of the invoicable period. Format: YYYY-MM-DD.
         * @format date
         */
        start_date: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Blob, void>({
        path: `/api/club_invoicable`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Retrieve a list of clubs with search and ordering filters. You can search clubs by name or district name, and order the results by various fields. Combined search and ordering can be used by specifying the desired search term and ordering fields.
     *
     * @tags clubs
     * @name ClubsList
     * @summary List clubs
     * @request GET:/api/clubs
     * @secure
     */
    clubsList: (
      query?: {
        district__id?: number;
        district__name?: string;
        id?: number;
        /** Is the club active */
        is_active?: boolean;
        name?: string;
        /** Order results by club name or district name in ascending or descending order. Multiple fields can be combined by separating them with commas. Examples include ordering by name ascending and district name descending. */
        ordering?:
          | "-district__name"
          | "-district__name,-name"
          | "-district__name,name"
          | "-name"
          | "-name,-district__name"
          | "-name,district__name"
          | "district__name"
          | "district__name,-name"
          | "district__name,name"
          | "name"
          | "name,-district__name"
          | "name,district__name";
        /** A page number within the paginated result set. */
        page?: number;
        /** Number of results to return per page. */
        page_size?: number;
        /** Search clubs by name or district name. Example: `?search=athletics` to find clubs with "athletics" in their name or district name. */
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedClubList, any>({
        path: `/api/clubs`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new club.
     *
     * @tags clubs
     * @name ClubsCreate
     * @summary Create a club
     * @request POST:/api/clubs
     * @secure
     */
    clubsCreate: (data: ClubWriteRequest, params: RequestParams = {}) =>
      this.request<Club, any>({
        path: `/api/clubs`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve a club by ID.
     *
     * @tags clubs
     * @name ClubsRetrieve
     * @summary Retrieve a club
     * @request GET:/api/clubs/{id}
     * @secure
     */
    clubsRetrieve: (id: number, params: RequestParams = {}) =>
      this.request<Club, any>({
        path: `/api/clubs/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update a club by ID.
     *
     * @tags clubs
     * @name ClubsUpdate
     * @summary Update a club
     * @request PUT:/api/clubs/{id}
     * @secure
     */
    clubsUpdate: (
      id: number,
      data: ClubWriteRequest,
      params: RequestParams = {},
    ) =>
      this.request<Club, any>({
        path: `/api/clubs/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * @description Partially update a club by ID.
     *
     * @tags clubs
     * @name ClubsPartialUpdate
     * @summary Partially update a club
     * @request PATCH:/api/clubs/{id}
     * @secure
     */
    clubsPartialUpdate: (
      id: number,
      data: PatchedClubWriteRequest,
      params: RequestParams = {},
    ) =>
      this.request<Club, any>({
        path: `/api/clubs/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a club by ID.
     *
     * @tags clubs
     * @name ClubsDestroy
     * @summary Delete a club
     * @request DELETE:/api/clubs/{id}
     * @secure
     */
    clubsDestroy: (id: number, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/clubs/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Add a club admin to the user by email.
     *
     * @tags clubs
     * @name ClubsAddClubAdminCreate
     * @request POST:/api/clubs/{id}/add_club_admin
     * @secure
     */
    clubsAddClubAdminCreate: (
      id: number,
      data: AddClubAdminRequestRequest,
      params: RequestParams = {},
    ) =>
      this.request<AddClubAdminResponse, void>({
        path: `/api/clubs/${id}/add_club_admin`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * @description List all club admins for the club.
     *
     * @tags clubs
     * @name ClubsListClubAdminsList
     * @request GET:/api/clubs/{id}/list_club_admins
     * @secure
     */
    clubsListClubAdminsList: (id: number, params: RequestParams = {}) =>
      this.request<ListAdmin[], any>({
        path: `/api/clubs/${id}/list_club_admins`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Remove a club admin from the user by email.
     *
     * @tags clubs
     * @name ClubsRemoveClubAdminCreate
     * @request POST:/api/clubs/{id}/remove_club_admin
     * @secure
     */
    clubsRemoveClubAdminCreate: (
      id: number,
      data: RemoveClubAdminRequestRequest,
      params: RequestParams = {},
    ) =>
      this.request<RemoveClubAdminResponse, void>({
        path: `/api/clubs/${id}/remove_club_admin`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * @description Returns a list of available competition categories with their category and label.
     *
     * @tags competition_categories
     * @name CompetitionCategoriesList
     * @summary Get list of competition categories
     * @request GET:/api/competition_categories/
     * @secure
     */
    competitionCategoriesList: (
      query?: {
        /** Flag to check if the user has permission to create a competition category. */
        permission_to_create?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<CompetitionCategory[], any>({
        path: `/api/competition_categories/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve a list of competition divisions.
     *
     * @tags competition_divisions
     * @name CompetitionDivisionsList
     * @summary List competition divisions
     * @request GET:/api/competition_divisions
     * @secure
     */
    competitionDivisionsList: (
      query?: {
        competition?: number;
        competition_type?: number;
        /**
         * * `M` - Herr
         * * `F` - Dam
         * * `B` - Blandat
         */
        gender?: "B" | "F" | "M";
        id?: number;
        /** Which field to use when ordering the results. */
        ordering?: string;
        /** A page number within the paginated result set. */
        page?: number;
        /** Number of results to return per page. */
        page_size?: number;
        /** A search term. */
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedCompetitionDivisionList, any>({
        path: `/api/competition_divisions`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new competition division.
     *
     * @tags competition_divisions
     * @name CompetitionDivisionsCreate
     * @summary Create a competition division
     * @request POST:/api/competition_divisions
     * @secure
     */
    competitionDivisionsCreate: (
      data: CompetitionDivisionWriteRequest,
      params: RequestParams = {},
    ) =>
      this.request<CompetitionDivision, any>({
        path: `/api/competition_divisions`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve a competition division by ID.
     *
     * @tags competition_divisions
     * @name CompetitionDivisionsRetrieve
     * @summary Retrieve a competition division
     * @request GET:/api/competition_divisions/{id}
     * @secure
     */
    competitionDivisionsRetrieve: (id: number, params: RequestParams = {}) =>
      this.request<CompetitionDivision, any>({
        path: `/api/competition_divisions/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update a competition division by ID.
     *
     * @tags competition_divisions
     * @name CompetitionDivisionsUpdate
     * @summary Update a competition division
     * @request PUT:/api/competition_divisions/{id}
     * @secure
     */
    competitionDivisionsUpdate: (
      id: number,
      data: CompetitionDivisionWriteRequest,
      params: RequestParams = {},
    ) =>
      this.request<CompetitionDivision, any>({
        path: `/api/competition_divisions/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * @description Partially update a competition division by ID.
     *
     * @tags competition_divisions
     * @name CompetitionDivisionsPartialUpdate
     * @summary Partially update a competition division
     * @request PATCH:/api/competition_divisions/{id}
     * @secure
     */
    competitionDivisionsPartialUpdate: (
      id: number,
      data: PatchedCompetitionDivisionWriteRequest,
      params: RequestParams = {},
    ) =>
      this.request<CompetitionDivision, any>({
        path: `/api/competition_divisions/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a competition division by ID.
     *
     * @tags competition_divisions
     * @name CompetitionDivisionsDestroy
     * @summary Delete a competition division
     * @request DELETE:/api/competition_divisions/{id}
     * @secure
     */
    competitionDivisionsDestroy: (id: number, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/competition_divisions/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags competition_files
     * @name CompetitionFilesList
     * @request GET:/api/competition_files
     * @secure
     */
    competitionFilesList: (params: RequestParams = {}) =>
      this.request<CompetitionFile[], any>({
        path: `/api/competition_files`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags competition_files
     * @name CompetitionFilesCreate
     * @request POST:/api/competition_files
     * @secure
     */
    competitionFilesCreate: (
      data: CompetitionFileRequest,
      params: RequestParams = {},
    ) =>
      this.request<CompetitionFile, any>({
        path: `/api/competition_files`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/x-www-form-urlencoded",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags competition_files
     * @name CompetitionFilesRetrieve
     * @request GET:/api/competition_files/{id}
     * @secure
     */
    competitionFilesRetrieve: (id: string, params: RequestParams = {}) =>
      this.request<CompetitionFile, any>({
        path: `/api/competition_files/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags competition_files
     * @name CompetitionFilesDestroy
     * @request DELETE:/api/competition_files/{id}
     * @secure
     */
    competitionFilesDestroy: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/competition_files/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Retrieve a list of competition teams.
     *
     * @tags competition_teams
     * @name CompetitionTeamsList
     * @summary List competition teams
     * @request GET:/api/competition_teams
     * @secure
     */
    competitionTeamsList: (
      query?: {
        club?: number;
        competition?: number;
        division?: number;
        id?: number;
        /** When registerable=true, check reserve slots instead of normal roster slots. Defaults to false. */
        is_reserve?: boolean;
        name?: string;
        /** Which field to use when ordering the results. */
        ordering?: string;
        /** A page number within the paginated result set. */
        page?: number;
        /** Number of results to return per page. */
        page_size?: number;
        /** Lifter person ID used with registerable=true. */
        person?: number;
        /** If true, only return teams the current user can choose when registering the selected lifter. */
        registerable?: boolean;
        /** A search term. */
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedCompetitionTeamList, any>({
        path: `/api/competition_teams`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new competition team.
     *
     * @tags competition_teams
     * @name CompetitionTeamsCreate
     * @summary Create a competition team
     * @request POST:/api/competition_teams
     * @secure
     */
    competitionTeamsCreate: (
      data: CompetitionTeamWriteRequest,
      params: RequestParams = {},
    ) =>
      this.request<CompetitionTeam, any>({
        path: `/api/competition_teams`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve a competition team by ID.
     *
     * @tags competition_teams
     * @name CompetitionTeamsRetrieve
     * @summary Retrieve a competition team
     * @request GET:/api/competition_teams/{id}
     * @secure
     */
    competitionTeamsRetrieve: (id: number, params: RequestParams = {}) =>
      this.request<CompetitionTeam, any>({
        path: `/api/competition_teams/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update a competition team by ID.
     *
     * @tags competition_teams
     * @name CompetitionTeamsUpdate
     * @summary Update a competition team
     * @request PUT:/api/competition_teams/{id}
     * @secure
     */
    competitionTeamsUpdate: (
      id: number,
      data: CompetitionTeamWriteRequest,
      params: RequestParams = {},
    ) =>
      this.request<CompetitionTeam, any>({
        path: `/api/competition_teams/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * @description Partially update a competition team by ID.
     *
     * @tags competition_teams
     * @name CompetitionTeamsPartialUpdate
     * @summary Partially update a competition team
     * @request PATCH:/api/competition_teams/{id}
     * @secure
     */
    competitionTeamsPartialUpdate: (
      id: number,
      data: PatchedCompetitionTeamWriteRequest,
      params: RequestParams = {},
    ) =>
      this.request<CompetitionTeam, any>({
        path: `/api/competition_teams/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a competition team by ID.
     *
     * @tags competition_teams
     * @name CompetitionTeamsDestroy
     * @summary Delete a competition team
     * @request DELETE:/api/competition_teams/{id}
     * @secure
     */
    competitionTeamsDestroy: (id: number, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/competition_teams/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Retrieve a list of competition types.
     *
     * @tags competition_types
     * @name CompetitionTypesList
     * @summary List competition types
     * @request GET:/api/competition_types
     * @secure
     */
    competitionTypesList: (
      query?: {
        /** Which field to use when ordering the results. */
        ordering?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CompetitionType[], any>({
        path: `/api/competition_types`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve a competition type by ID.
     *
     * @tags competition_types
     * @name CompetitionTypesRetrieve
     * @summary Retrieve a competition type
     * @request GET:/api/competition_types/{id}
     * @secure
     */
    competitionTypesRetrieve: (id: number, params: RequestParams = {}) =>
      this.request<CompetitionType, any>({
        path: `/api/competition_types/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve a list of competitions.
     *
     * @tags competitions
     * @name CompetitionsList
     * @summary List competitions
     * @request GET:/api/competitions
     * @secure
     */
    competitionsList: (
      query?: {
        /**
         * * `WG` - World Games
         * * `VM` - VM
         * * `EM` - EM
         * * `NM` - NM
         * * `INT` - Internationell
         * * `SM` - SM
         * * `RM` - RM
         * * `LDM` - LDM
         * * `DM` - DM
         * * `GENERAL` - Serie/Övrig
         * * `KM` - KM
         */
        category?: (
          | "DM"
          | "EM"
          | "GENERAL"
          | "INT"
          | "KM"
          | "LDM"
          | "NM"
          | "RM"
          | "SM"
          | "VM"
          | "WG"
        )[];
        districts?: number[];
        /** @format date */
        from_end_date?: string;
        /** @format date */
        from_start_date?: string;
        id?: number;
        is_closed?: boolean;
        is_team_comp?: boolean;
        name?: string;
        /** Which field to use when ordering the results. */
        ordering?: string;
        /** A page number within the paginated result set. */
        page?: number;
        /** Number of results to return per page. */
        page_size?: number;
        registration_open?: boolean;
        /** A search term. */
        search?: string;
        /**
         * * `CREATED` - Created
         * * `PUBLISHED` - Published
         * * `CLOSED` - Closed
         * * `ARCHIVED` - Archived
         */
        state?: ("ARCHIVED" | "CLOSED" | "CREATED" | "PUBLISHED")[];
        /** @format date */
        to_end_date?: string;
        /** @format date */
        to_start_date?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedCompetitionListList, any>({
        path: `/api/competitions`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new competition.
     *
     * @tags competitions
     * @name CompetitionsCreate
     * @summary Create a competition
     * @request POST:/api/competitions
     * @secure
     */
    competitionsCreate: (
      data: CompetitionRequest,
      params: RequestParams = {},
    ) =>
      this.request<Competition, any>({
        path: `/api/competitions`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve a competition by ID.
     *
     * @tags competitions
     * @name CompetitionsRetrieve
     * @summary Retrieve a competition
     * @request GET:/api/competitions/{id}
     * @secure
     */
    competitionsRetrieve: (id: number, params: RequestParams = {}) =>
      this.request<CompetitionDetail, any>({
        path: `/api/competitions/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update a competition by ID.
     *
     * @tags competitions
     * @name CompetitionsUpdate
     * @summary Update a competition
     * @request PUT:/api/competitions/{id}
     * @secure
     */
    competitionsUpdate: (
      id: number,
      data: CompetitionRequest,
      params: RequestParams = {},
    ) =>
      this.request<Competition, any>({
        path: `/api/competitions/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * @description Partially update a competition by ID.
     *
     * @tags competitions
     * @name CompetitionsPartialUpdate
     * @summary Partially update a competition
     * @request PATCH:/api/competitions/{id}
     * @secure
     */
    competitionsPartialUpdate: (
      id: number,
      data: PatchedCompetitionRequest,
      params: RequestParams = {},
    ) =>
      this.request<Competition, any>({
        path: `/api/competitions/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a competition by ID.
     *
     * @tags competitions
     * @name CompetitionsDestroy
     * @summary Delete a competition
     * @request DELETE:/api/competitions/{id}
     * @secure
     */
    competitionsDestroy: (id: number, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/competitions/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Add a competition admin to the user by email.
     *
     * @tags competitions
     * @name CompetitionsAddCompetitionAdminCreate
     * @request POST:/api/competitions/{id}/add_competition_admin
     * @secure
     */
    competitionsAddCompetitionAdminCreate: (
      id: number,
      data: AddCompetitionAdminRequestRequest,
      params: RequestParams = {},
    ) =>
      this.request<AddCompetitionAdminResponse, void>({
        path: `/api/competitions/${id}/add_competition_admin`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve detailed competition info with team-oriented standings and results.
     *
     * @tags competitions
     * @name CompetitionsDetailTeamRetrieve
     * @summary Retrieve competition team detail
     * @request GET:/api/competitions/{id}/detail_team
     * @secure
     */
    competitionsDetailTeamRetrieve: (id: number, params: RequestParams = {}) =>
      this.request<CompetitionTeamDetail, any>({
        path: `/api/competitions/${id}/detail_team`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Download registrations for this competition as a CSV file
     *
     * @tags competitions
     * @name CompetitionsExportRegistrationsRetrieve
     * @summary Export registrations as CSV
     * @request GET:/api/competitions/{id}/export_registrations
     * @secure
     */
    competitionsExportRegistrationsRetrieve: (
      id: number,
      query?: {
        /** Include/exclude approved registrations. */
        is_approved?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/competitions/${id}/export_registrations`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Get registration categories for a competition.
     *
     * @tags competitions
     * @name CompetitionsGetRegistrationCategoriesRetrieve
     * @request GET:/api/competitions/{id}/get_registration_categories
     * @secure
     */
    competitionsGetRegistrationCategoriesRetrieve: (
      id: number,
      params: RequestParams = {},
    ) =>
      this.request<RegistrationCategory[], void>({
        path: `/api/competitions/${id}/get_registration_categories`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns a structured summary of the registration categories for a competition.
     *
     * @tags competitions
     * @name CompetitionsGetRegistrationCategoriesSummaryList
     * @summary Get registration categories summary
     * @request GET:/api/competitions/{id}/get_registration_categories_summary
     * @secure
     */
    competitionsGetRegistrationCategoriesSummaryList: (
      id: number,
      params: RequestParams = {},
    ) =>
      this.request<RegistrationCategoriesSummaryResponse[], any>({
        path: `/api/competitions/${id}/get_registration_categories_summary`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description List all competition admins for the competition.
     *
     * @tags competitions
     * @name CompetitionsListCompetitionAdminsRetrieve
     * @request GET:/api/competitions/{id}/list_competition_admins
     * @secure
     */
    competitionsListCompetitionAdminsRetrieve: (
      id: number,
      params: RequestParams = {},
    ) =>
      this.request<ListCompetitionAdminsResponse, any>({
        path: `/api/competitions/${id}/list_competition_admins`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags competitions
     * @name CompetitionsRegenerateApiKeyCreate
     * @request POST:/api/competitions/{id}/regenerate_api_key
     * @secure
     */
    competitionsRegenerateApiKeyCreate: (
      id: number,
      data: CompetitionRequest,
      params: RequestParams = {},
    ) =>
      this.request<Competition, any>({
        path: `/api/competitions/${id}/regenerate_api_key`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * @description Remove a competition admin from the user by email.
     *
     * @tags competitions
     * @name CompetitionsRemoveCompetitionAdminCreate
     * @request POST:/api/competitions/{id}/remove_competition_admin
     * @secure
     */
    competitionsRemoveCompetitionAdminCreate: (
      id: number,
      data: RemoveCompetitionAdminRequestRequest,
      params: RequestParams = {},
    ) =>
      this.request<RemoveCompetitionAdminResponse, void>({
        path: `/api/competitions/${id}/remove_competition_admin`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * @description Bulk set registration categories for a competition.
     *
     * @tags competitions
     * @name CompetitionsSetRegistrationCategoriesCreate
     * @request POST:/api/competitions/{id}/set_registration_categories
     * @secure
     */
    competitionsSetRegistrationCategoriesCreate: (
      id: number,
      data: RegistrationCategoryBulkWriteRequest[],
      params: RequestParams = {},
    ) =>
      this.request<RegistrationCategory[], void>({
        path: `/api/competitions/${id}/set_registration_categories`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve a list of districts with search and ordering filters. You can search districts by name or region name, and order the results by various fields. Ordering fields can be combined by separating them with commas. Example: `?search=central&ordering=name,-region__name`.
     *
     * @tags districts
     * @name DistrictsList
     * @summary List districts
     * @request GET:/api/districts
     * @secure
     */
    districtsList: (
      query?: {
        id?: number;
        name?: string;
        /** Order results by district name or region name in ascending or descending order. Multiple fields can be combined by separating them with commas. Example: `?ordering=name,-region__name`. */
        ordering?:
          | "-name"
          | "-name,-region__name"
          | "-name,region__name"
          | "-region__name"
          | "-region__name,-name"
          | "-region__name,name"
          | "name"
          | "name,-region__name"
          | "name,region__name"
          | "region__name"
          | "region__name,-name"
          | "region__name,name";
        /** A page number within the paginated result set. */
        page?: number;
        /** Number of results to return per page. */
        page_size?: number;
        region__id?: number;
        region__name?: string;
        /** Search districts by name or region name. Example: `?search=central` will find districts with "central" in their name or region name. */
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedDistrictList, any>({
        path: `/api/districts`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new district.
     *
     * @tags districts
     * @name DistrictsCreate
     * @summary Create a district
     * @request POST:/api/districts
     * @secure
     */
    districtsCreate: (data: DistrictWriteRequest, params: RequestParams = {}) =>
      this.request<District, any>({
        path: `/api/districts`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve a district by ID.
     *
     * @tags districts
     * @name DistrictsRetrieve
     * @summary Retrieve a district
     * @request GET:/api/districts/{id}
     * @secure
     */
    districtsRetrieve: (id: number, params: RequestParams = {}) =>
      this.request<District, any>({
        path: `/api/districts/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update a district by ID.
     *
     * @tags districts
     * @name DistrictsUpdate
     * @summary Update a district
     * @request PUT:/api/districts/{id}
     * @secure
     */
    districtsUpdate: (
      id: number,
      data: DistrictWriteRequest,
      params: RequestParams = {},
    ) =>
      this.request<District, any>({
        path: `/api/districts/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * @description Partially update a district by ID.
     *
     * @tags districts
     * @name DistrictsPartialUpdate
     * @summary Partially update a district
     * @request PATCH:/api/districts/{id}
     * @secure
     */
    districtsPartialUpdate: (
      id: number,
      data: PatchedDistrictWriteRequest,
      params: RequestParams = {},
    ) =>
      this.request<District, any>({
        path: `/api/districts/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a district by ID.
     *
     * @tags districts
     * @name DistrictsDestroy
     * @summary Delete a district
     * @request DELETE:/api/districts/{id}
     * @secure
     */
    districtsDestroy: (id: number, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/districts/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Add a district admin to the user by email.
     *
     * @tags districts
     * @name DistrictsAddDistrictAdminCreate
     * @request POST:/api/districts/{id}/add_district_admin
     * @secure
     */
    districtsAddDistrictAdminCreate: (
      id: number,
      data: AddDistrictAdminRequestRequest,
      params: RequestParams = {},
    ) =>
      this.request<AddDistrictAdminResponse, void>({
        path: `/api/districts/${id}/add_district_admin`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * @description List all district admins for the district.
     *
     * @tags districts
     * @name DistrictsListDistrictAdminsList
     * @request GET:/api/districts/{id}/list_district_admins
     * @secure
     */
    districtsListDistrictAdminsList: (id: number, params: RequestParams = {}) =>
      this.request<ListAdmin[], any>({
        path: `/api/districts/${id}/list_district_admins`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Remove a district admin from the user by email.
     *
     * @tags districts
     * @name DistrictsRemoveDistrictAdminCreate
     * @request POST:/api/districts/{id}/remove_district_admin
     * @secure
     */
    districtsRemoveDistrictAdminCreate: (
      id: number,
      data: RemoveDistrictAdminRequestRequest,
      params: RequestParams = {},
    ) =>
      this.request<RemoveDistrictAdminResponse, void>({
        path: `/api/districts/${id}/remove_district_admin`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve a list of divisions.
     *
     * @tags divisions
     * @name DivisionsList
     * @summary List divisions
     * @request GET:/api/divisions
     * @secure
     */
    divisionsList: (
      query?: {
        id?: number;
        /** Which field to use when ordering the results. */
        ordering?: string;
        /** A page number within the paginated result set. */
        page?: number;
        /** Number of results to return per page. */
        page_size?: number;
        /** A search term. */
        search?: string;
        series?: number;
        year?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedDivisionList, any>({
        path: `/api/divisions`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new division.
     *
     * @tags divisions
     * @name DivisionsCreate
     * @summary Create a division
     * @request POST:/api/divisions
     * @secure
     */
    divisionsCreate: (data: DivisionWriteRequest, params: RequestParams = {}) =>
      this.request<Division, any>({
        path: `/api/divisions`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve a division by ID.
     *
     * @tags divisions
     * @name DivisionsRetrieve
     * @summary Retrieve a division
     * @request GET:/api/divisions/{id}
     * @secure
     */
    divisionsRetrieve: (id: number, params: RequestParams = {}) =>
      this.request<DivisionDetailed, any>({
        path: `/api/divisions/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update a division by ID.
     *
     * @tags divisions
     * @name DivisionsUpdate
     * @summary Update a division
     * @request PUT:/api/divisions/{id}
     * @secure
     */
    divisionsUpdate: (
      id: number,
      data: DivisionWriteRequest,
      params: RequestParams = {},
    ) =>
      this.request<Division, any>({
        path: `/api/divisions/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * @description Partially update a division by ID.
     *
     * @tags divisions
     * @name DivisionsPartialUpdate
     * @summary Partially update a division
     * @request PATCH:/api/divisions/{id}
     * @secure
     */
    divisionsPartialUpdate: (
      id: number,
      data: PatchedDivisionWriteRequest,
      params: RequestParams = {},
    ) =>
      this.request<Division, any>({
        path: `/api/divisions/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a division by ID.
     *
     * @tags divisions
     * @name DivisionsDestroy
     * @summary Delete a division
     * @request DELETE:/api/divisions/{id}
     * @secure
     */
    divisionsDestroy: (id: number, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/divisions/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description OpenApi3 schema for this API. Format can be selected via content negotiation. - YAML: application/vnd.oai.openapi - JSON: application/vnd.oai.openapi+json
     *
     * @tags doc
     * @name DocRetrieve
     * @request GET:/api/doc/
     * @secure
     */
    docRetrieve: (
      query?: {
        format?: "json" | "yaml";
        lang?:
          | "af"
          | "ar"
          | "ar-dz"
          | "ast"
          | "az"
          | "be"
          | "bg"
          | "bn"
          | "br"
          | "bs"
          | "ca"
          | "ckb"
          | "cs"
          | "cy"
          | "da"
          | "de"
          | "dsb"
          | "el"
          | "en"
          | "en-au"
          | "en-gb"
          | "eo"
          | "es"
          | "es-ar"
          | "es-co"
          | "es-mx"
          | "es-ni"
          | "es-ve"
          | "et"
          | "eu"
          | "fa"
          | "fi"
          | "fr"
          | "fy"
          | "ga"
          | "gd"
          | "gl"
          | "he"
          | "hi"
          | "hr"
          | "hsb"
          | "hu"
          | "hy"
          | "ia"
          | "id"
          | "ig"
          | "io"
          | "is"
          | "it"
          | "ja"
          | "ka"
          | "kab"
          | "kk"
          | "km"
          | "kn"
          | "ko"
          | "ky"
          | "lb"
          | "lt"
          | "lv"
          | "mk"
          | "ml"
          | "mn"
          | "mr"
          | "ms"
          | "my"
          | "nb"
          | "ne"
          | "nl"
          | "nn"
          | "os"
          | "pa"
          | "pl"
          | "pt"
          | "pt-br"
          | "ro"
          | "ru"
          | "sk"
          | "sl"
          | "sq"
          | "sr"
          | "sr-latn"
          | "sv"
          | "sw"
          | "ta"
          | "te"
          | "tg"
          | "th"
          | "tk"
          | "tr"
          | "tt"
          | "udm"
          | "ug"
          | "uk"
          | "ur"
          | "uz"
          | "vi"
          | "zh-hans"
          | "zh-hant";
      },
      params: RequestParams = {},
    ) =>
      this.request<Record<string, any>, any>({
        path: `/api/doc/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve a list of groups.
     *
     * @tags groups
     * @name GroupsList
     * @summary List groups
     * @request GET:/api/groups
     * @secure
     */
    groupsList: (
      query?: {
        competition?: number;
        id?: number;
        /** Which field to use when ordering the results. */
        ordering?: string;
        /** A page number within the paginated result set. */
        page?: number;
        /** Number of results to return per page. */
        page_size?: number;
        /** A search term. */
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedGroupList, any>({
        path: `/api/groups`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new group.
     *
     * @tags groups
     * @name GroupsCreate
     * @summary Create a group
     * @request POST:/api/groups
     * @secure
     */
    groupsCreate: (data: GroupWriteRequest, params: RequestParams = {}) =>
      this.request<Group, any>({
        path: `/api/groups`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve a group by ID.
     *
     * @tags groups
     * @name GroupsRetrieve
     * @summary Retrieve a group
     * @request GET:/api/groups/{id}
     * @secure
     */
    groupsRetrieve: (id: number, params: RequestParams = {}) =>
      this.request<GroupDetail, any>({
        path: `/api/groups/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update a group by ID.
     *
     * @tags groups
     * @name GroupsUpdate
     * @summary Update a group
     * @request PUT:/api/groups/{id}
     * @secure
     */
    groupsUpdate: (
      id: number,
      data: GroupWriteRequest,
      params: RequestParams = {},
    ) =>
      this.request<Group, any>({
        path: `/api/groups/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * @description Partially update a group by ID.
     *
     * @tags groups
     * @name GroupsPartialUpdate
     * @summary Partially update a group
     * @request PATCH:/api/groups/{id}
     * @secure
     */
    groupsPartialUpdate: (
      id: number,
      data: PatchedGroupWriteRequest,
      params: RequestParams = {},
    ) =>
      this.request<Group, any>({
        path: `/api/groups/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a group by ID.
     *
     * @tags groups
     * @name GroupsDestroy
     * @summary Delete a group
     * @request DELETE:/api/groups/{id}
     * @secure
     */
    groupsDestroy: (id: number, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/groups/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Attempts to establish a connection to the primary database. Returns 200 when successful, else 503 to signal the service is not fully available.
     *
     * @tags Infrastructure
     * @name HealthRetrieve
     * @summary Service health check
     * @request GET:/api/health/
     * @secure
     */
    healthRetrieve: (params: RequestParams = {}) =>
      this.request<HealthOK, HealthError>({
        path: `/api/health/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves competition data including registrations in Powerlifting Live format. Requires a valid API Key to be passed in the header, associated with the competition.
     *
     * @tags integrations
     * @name IntegrationsPowerliftingliveCompetitionRetrieve
     * @request GET:/api/integrations/powerliftinglive_competition
     * @secure
     */
    integrationsPowerliftingliveCompetitionRetrieve: (
      params: RequestParams = {},
    ) =>
      this.request<PLCompetition, ErrorResponse>({
        path: `/api/integrations/powerliftinglive_competition`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Accepts a list of groups and results and saves them to the database. All existing groups and results are removed upon success.Requires a valid API Key to be passed in the header, associated with the competition.
     *
     * @tags integrations
     * @name IntegrationsPowerliftingliveResultsCreate
     * @request POST:/api/integrations/powerliftinglive_results
     * @secure
     */
    integrationsPowerliftingliveResultsCreate: (
      data: PLCompetitionResultRequest,
      params: RequestParams = {},
    ) =>
      this.request<ResultSuccess, ErrorResponse>({
        path: `/api/integrations/powerliftinglive_results`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve a list of judge duties.
     *
     * @tags judge_duties
     * @name JudgeDutiesList
     * @summary List judge duties
     * @request GET:/api/judge_duties
     * @secure
     */
    judgeDutiesList: (
      query?: {
        book?: number;
        competition?: number;
        group?: number;
        id?: number;
        judge?: number;
        /**
         * Order results by fields (comma separated). Prefix with `-` for descending.
         *
         * Supported values:
         * * `group_name`
         * * `group_start`
         * * `id`
         * * `role_name`
         * * `judge_first_name`
         * * `judge_last_name`
         *
         * Deep-path equivalents are also accepted: `group__name`, `group__start`, `role__name`, `judge_license__judge__person__first_name`, `judge_license__judge__person__last_name`.
         */
        ordering?: string;
        /** A page number within the paginated result set. */
        page?: number;
        /** Number of results to return per page. */
        page_size?: number;
        person?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedJudgeDutyList, any>({
        path: `/api/judge_duties`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new judge duty.
     *
     * @tags judge_duties
     * @name JudgeDutiesCreate
     * @summary Create a judge duty
     * @request POST:/api/judge_duties
     * @secure
     */
    judgeDutiesCreate: (
      data: JudgeDutyWriteRequest,
      params: RequestParams = {},
    ) =>
      this.request<JudgeDuty, any>({
        path: `/api/judge_duties`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags judge_duties
     * @name JudgeDutiesRetrieve
     * @request GET:/api/judge_duties/{id}
     * @secure
     */
    judgeDutiesRetrieve: (id: number, params: RequestParams = {}) =>
      this.request<JudgeDuty, any>({
        path: `/api/judge_duties/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update a judge duty by ID.
     *
     * @tags judge_duties
     * @name JudgeDutiesUpdate
     * @summary Update a judge duty
     * @request PUT:/api/judge_duties/{id}
     * @secure
     */
    judgeDutiesUpdate: (
      id: number,
      data: JudgeDutyWriteRequest,
      params: RequestParams = {},
    ) =>
      this.request<JudgeDuty, any>({
        path: `/api/judge_duties/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * @description Partially update a judge duty by ID.
     *
     * @tags judge_duties
     * @name JudgeDutiesPartialUpdate
     * @summary Partially update a judge duty
     * @request PATCH:/api/judge_duties/{id}
     * @secure
     */
    judgeDutiesPartialUpdate: (
      id: number,
      data: PatchedJudgeDutyWriteRequest,
      params: RequestParams = {},
    ) =>
      this.request<JudgeDuty, any>({
        path: `/api/judge_duties/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags judge_duties
     * @name JudgeDutiesDestroy
     * @request DELETE:/api/judge_duties/{id}
     * @secure
     */
    judgeDutiesDestroy: (id: number, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/judge_duties/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags judge_licenses
     * @name JudgeLicensesList
     * @request GET:/api/judge_licenses
     * @secure
     */
    judgeLicensesList: (
      query?: {
        book?: number;
        club?: number;
        id?: number;
        judge?: number;
        /** Which field to use when ordering the results. */
        ordering?: string;
        /** A page number within the paginated result set. */
        page?: number;
        /** Number of results to return per page. */
        page_size?: number;
        person?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedJudgeLicenseList, any>({
        path: `/api/judge_licenses`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags judge_licenses
     * @name JudgeLicensesCreate
     * @request POST:/api/judge_licenses
     * @secure
     */
    judgeLicensesCreate: (
      data: JudgeLicenseWriteRequest,
      params: RequestParams = {},
    ) =>
      this.request<JudgeLicenseWrite, any>({
        path: `/api/judge_licenses`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags judge_licenses
     * @name JudgeLicensesRetrieve
     * @request GET:/api/judge_licenses/{id}
     * @secure
     */
    judgeLicensesRetrieve: (id: number, params: RequestParams = {}) =>
      this.request<JudgeLicense, any>({
        path: `/api/judge_licenses/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags judge_licenses
     * @name JudgeLicensesUpdate
     * @request PUT:/api/judge_licenses/{id}
     * @secure
     */
    judgeLicensesUpdate: (
      id: number,
      data: JudgeLicenseWriteRequest,
      params: RequestParams = {},
    ) =>
      this.request<JudgeLicenseWrite, any>({
        path: `/api/judge_licenses/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags judge_licenses
     * @name JudgeLicensesPartialUpdate
     * @request PATCH:/api/judge_licenses/{id}
     * @secure
     */
    judgeLicensesPartialUpdate: (
      id: number,
      data: PatchedJudgeLicenseWriteRequest,
      params: RequestParams = {},
    ) =>
      this.request<JudgeLicenseWrite, any>({
        path: `/api/judge_licenses/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags judge_licenses
     * @name JudgeLicensesDestroy
     * @request DELETE:/api/judge_licenses/{id}
     * @secure
     */
    judgeLicensesDestroy: (id: number, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/judge_licenses/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Returns a list of available judge roles with their role and label.
     *
     * @tags judge_roles
     * @name JudgeRolesList
     * @summary Get list of judge roles
     * @request GET:/api/judge_roles/
     * @secure
     */
    judgeRolesList: (params: RequestParams = {}) =>
      this.request<JudgeRoles[], any>({
        path: `/api/judge_roles/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve a list of judges.
     *
     * @tags judges
     * @name JudgesList
     * @summary List judges
     * @request GET:/api/judges
     * @secure
     */
    judgesList: (
      query?: {
        book?: number;
        club?: number;
        district?: number;
        id?: number;
        /**
         * Show whether a judge is licensed on a specific date. Defaults to today.
         * @format date
         */
        is_licensed_on?: string;
        /**
         * * `D` - Distriktsdomare
         * * `F` - Förbundsdomare
         * * `K2` - Kat 2. Domare
         * * `K1` - Kat 1. Domare
         */
        level?: ("D" | "F" | "K1" | "K2")[];
        /** Which field to use when ordering the results. */
        ordering?: string;
        /** A page number within the paginated result set. */
        page?: number;
        /** Number of results to return per page. */
        page_size?: number;
        person?: number;
        person__club?: number;
        person__club__district?: number;
        person__club__district__name?: string;
        person__club__name?: string;
        /** A search term. */
        search?: string;
        /**
         * * `active` - Aktiv
         * * `warned` - Varnad
         * * `suspended` - Avstängd
         * * `unknown` - Okänd
         */
        status?: ("active" | "suspended" | "unknown" | "warned")[];
        status_list?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedJudgeList, any>({
        path: `/api/judges`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags judges
     * @name JudgesCreate
     * @request POST:/api/judges
     * @secure
     */
    judgesCreate: (data: JudgeWriteRequest, params: RequestParams = {}) =>
      this.request<JudgeWrite, any>({
        path: `/api/judges`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags judges
     * @name JudgesRetrieve
     * @request GET:/api/judges/{id}
     * @secure
     */
    judgesRetrieve: (id: number, params: RequestParams = {}) =>
      this.request<JudgeSerializerGet, any>({
        path: `/api/judges/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags judges
     * @name JudgesUpdate
     * @request PUT:/api/judges/{id}
     * @secure
     */
    judgesUpdate: (
      id: number,
      data: JudgeWriteRequest,
      params: RequestParams = {},
    ) =>
      this.request<JudgeWrite, any>({
        path: `/api/judges/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags judges
     * @name JudgesPartialUpdate
     * @request PATCH:/api/judges/{id}
     * @secure
     */
    judgesPartialUpdate: (
      id: number,
      data: PatchedJudgeWriteRequest,
      params: RequestParams = {},
    ) =>
      this.request<JudgeWrite, any>({
        path: `/api/judges/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags judges
     * @name JudgesDestroy
     * @request DELETE:/api/judges/{id}
     * @secure
     */
    judgesDestroy: (id: number, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/judges/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags judges_admin
     * @name JudgesAdminList
     * @request GET:/api/judges_admin
     * @secure
     */
    judgesAdminList: (
      query?: {
        book?: number;
        club?: number;
        district?: number;
        id?: number;
        /**
         * * `D` - Distriktsdomare
         * * `F` - Förbundsdomare
         * * `K2` - Kat 2. Domare
         * * `K1` - Kat 1. Domare
         */
        level?: ("D" | "F" | "K1" | "K2")[];
        /** Which field to use when ordering the results. */
        ordering?: string;
        /** A page number within the paginated result set. */
        page?: number;
        /** Number of results to return per page. */
        page_size?: number;
        person?: number;
        person__club?: number;
        person__club__district?: number;
        person__club__district__name?: string;
        person__club__name?: string;
        /** A search term. */
        search?: string;
        /**
         * * `active` - Aktiv
         * * `warned` - Varnad
         * * `suspended` - Avstängd
         * * `unknown` - Okänd
         */
        status?: ("active" | "suspended" | "unknown" | "warned")[];
        status_list?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedJudgeSerializerDetailedList, any>({
        path: `/api/judges_admin`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags judges_admin
     * @name JudgesAdminRetrieve
     * @request GET:/api/judges_admin/{id}
     * @secure
     */
    judgesAdminRetrieve: (id: number, params: RequestParams = {}) =>
      this.request<JudgeSerializerDetailedGet, any>({
        path: `/api/judges_admin/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve a list of licenses.
     *
     * @tags licenses
     * @name LicensesList
     * @summary List licenses
     * @request GET:/api/licenses
     * @secure
     */
    licensesList: (
      query?: {
        club?: number;
        license_id?: string;
        /** Which field to use when ordering the results. */
        ordering?: string;
        /** A page number within the paginated result set. */
        page?: number;
        /** Number of results to return per page. */
        page_size?: number;
        person?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedLicenseList, any>({
        path: `/api/licenses`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new license.
     *
     * @tags licenses
     * @name LicensesCreate
     * @summary Create a license
     * @request POST:/api/licenses
     * @secure
     */
    licensesCreate: (data: LicenseWriteRequest, params: RequestParams = {}) =>
      this.request<LicenseWrite, any>({
        path: `/api/licenses`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve a license by ID.
     *
     * @tags licenses
     * @name LicensesRetrieve
     * @summary Retrieve a license
     * @request GET:/api/licenses/{id}
     * @secure
     */
    licensesRetrieve: (id: number, params: RequestParams = {}) =>
      this.request<License, any>({
        path: `/api/licenses/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update a license by ID.
     *
     * @tags licenses
     * @name LicensesUpdate
     * @summary Update a license
     * @request PUT:/api/licenses/{id}
     * @secure
     */
    licensesUpdate: (
      id: number,
      data: LicenseWriteRequest,
      params: RequestParams = {},
    ) =>
      this.request<LicenseWrite, any>({
        path: `/api/licenses/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * @description Partially update a license by ID.
     *
     * @tags licenses
     * @name LicensesPartialUpdate
     * @summary Partially update a license
     * @request PATCH:/api/licenses/{id}
     * @secure
     */
    licensesPartialUpdate: (
      id: number,
      data: PatchedLicenseWriteRequest,
      params: RequestParams = {},
    ) =>
      this.request<LicenseWrite, any>({
        path: `/api/licenses/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a license by ID.
     *
     * @tags licenses
     * @name LicensesDestroy
     * @summary Delete a license
     * @request DELETE:/api/licenses/{id}
     * @secure
     */
    licensesDestroy: (id: number, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/licenses/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Retrieve a list of people with search and ordering filters.
     *
     * @tags people
     * @name PeopleList
     * @summary List people
     * @request GET:/api/people
     * @secure
     */
    peopleList: (
      query?: {
        age_category?: number;
        /** When supplied, include can_register for each person. The value is true when the current user may create a registration for that person in the competition and the person has a valid license on the competition start date. */
        can_register_for_competition?: number;
        club?: number;
        district?: number;
        /** @format date */
        filter_date?: string;
        first_name?: string;
        /**
         * Show whether a person is licensed on a specific date. Defaults to today.
         * @format date
         */
        is_licensed_on?: string;
        last_name?: string;
        license_id?: string;
        /** Filter persons who had at least one valid license during the given year. */
        license_year?: number;
        /** Order results by first name, last name, club name, club ID, or latest license year. */
        ordering?:
          | "-club"
          | "-club__name"
          | "-first_name"
          | "-last_name"
          | "-license_year"
          | "club"
          | "club__name"
          | "first_name"
          | "last_name"
          | "license_year";
        /** A page number within the paginated result set. */
        page?: number;
        /** Number of results to return per page. */
        page_size?: number;
        /** Search by first name, last name, or club name. */
        search?: string;
        /** @format date */
        valid_license_on?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedPersonSerializerResponseList, any>({
        path: `/api/people`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new person.
     *
     * @tags people
     * @name PeopleCreate
     * @summary Create a person
     * @request POST:/api/people
     * @secure
     */
    peopleCreate: (data: PersonRequest, params: RequestParams = {}) =>
      this.request<PersonSerializerResponse, any>({
        path: `/api/people`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve a person by ID.
     *
     * @tags people
     * @name PeopleRetrieve
     * @summary Retrieve a person
     * @request GET:/api/people/{id}
     * @secure
     */
    peopleRetrieve: (
      id: number,
      query?: {
        /** When supplied, include can_register for this person. The value is true when the current user may create a registration for that person in the competition and the person has a valid license on the competition start date. */
        can_register_for_competition?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PersonSerializerResponse, any>({
        path: `/api/people/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update a person by ID.
     *
     * @tags people
     * @name PeopleUpdate
     * @summary Update a person
     * @request PUT:/api/people/{id}
     * @secure
     */
    peopleUpdate: (
      id: number,
      data: PersonRequest,
      params: RequestParams = {},
    ) =>
      this.request<PersonSerializerResponse, any>({
        path: `/api/people/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * @description Partially update a person by ID.
     *
     * @tags people
     * @name PeoplePartialUpdate
     * @summary Partially update a person
     * @request PATCH:/api/people/{id}
     * @secure
     */
    peoplePartialUpdate: (
      id: number,
      data: PatchedPersonRequest,
      params: RequestParams = {},
    ) =>
      this.request<PersonSerializerResponse, any>({
        path: `/api/people/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a person by ID.
     *
     * @tags people
     * @name PeopleDestroy
     * @summary Delete a person
     * @request DELETE:/api/people/{id}
     * @secure
     */
    peopleDestroy: (id: number, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/people/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Returns the detailed data of a person based on their ID.
     *
     * @tags people
     * @name PeopleDetailsRetrieve
     * @summary Retrieve detailed information about a person
     * @request GET:/api/people/{id}/details
     * @secure
     */
    peopleDetailsRetrieve: (id: number, params: RequestParams = {}) =>
      this.request<PersonSerializerDetailed, any>({
        path: `/api/people/${id}/details`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns a list of available points types with their name and label.
     *
     * @tags points_types
     * @name PointsTypesList
     * @summary Get list of points types
     * @request GET:/api/points_types/
     * @secure
     */
    pointsTypesList: (params: RequestParams = {}) =>
      this.request<PointsType[], any>({
        path: `/api/points_types/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags regions
     * @name RegionsList
     * @request GET:/api/regions
     * @secure
     */
    regionsList: (params: RequestParams = {}) =>
      this.request<Region[], any>({
        path: `/api/regions`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags regions
     * @name RegionsRetrieve
     * @request GET:/api/regions/{id}
     * @secure
     */
    regionsRetrieve: (id: number, params: RequestParams = {}) =>
      this.request<Region, any>({
        path: `/api/regions/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve a list of registration categories.
     *
     * @tags registration_categories
     * @name RegistrationCategoriesList
     * @summary List registration categories
     * @request GET:/api/registration_categories
     * @secure
     */
    registrationCategoriesList: (
      query?: {
        competition?: number;
        id?: number;
        /** Which field to use when ordering the results. */
        ordering?: string;
        /** A page number within the paginated result set. */
        page?: number;
        /** Number of results to return per page. */
        page_size?: number;
        /** A search term. */
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedRegistrationCategoryList, any>({
        path: `/api/registration_categories`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new registration categories.
     *
     * @tags registration_categories
     * @name RegistrationCategoriesCreate
     * @summary Create a registration categories
     * @request POST:/api/registration_categories
     * @secure
     */
    registrationCategoriesCreate: (
      data: RegistrationCategoryWriteRequest,
      params: RequestParams = {},
    ) =>
      this.request<RegistrationCategory, any>({
        path: `/api/registration_categories`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve a registration categories by ID.
     *
     * @tags registration_categories
     * @name RegistrationCategoriesRetrieve
     * @summary Retrieve a registration categories
     * @request GET:/api/registration_categories/{id}
     * @secure
     */
    registrationCategoriesRetrieve: (id: number, params: RequestParams = {}) =>
      this.request<RegistrationCategory, any>({
        path: `/api/registration_categories/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update a registration categories by ID.
     *
     * @tags registration_categories
     * @name RegistrationCategoriesUpdate
     * @summary Update a registration categories
     * @request PUT:/api/registration_categories/{id}
     * @secure
     */
    registrationCategoriesUpdate: (
      id: number,
      data: RegistrationCategoryWriteRequest,
      params: RequestParams = {},
    ) =>
      this.request<RegistrationCategory, any>({
        path: `/api/registration_categories/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * @description Partially update a registration categories by ID.
     *
     * @tags registration_categories
     * @name RegistrationCategoriesPartialUpdate
     * @summary Partially update a registration categories
     * @request PATCH:/api/registration_categories/{id}
     * @secure
     */
    registrationCategoriesPartialUpdate: (
      id: number,
      data: PatchedRegistrationCategoryWriteRequest,
      params: RequestParams = {},
    ) =>
      this.request<RegistrationCategory, any>({
        path: `/api/registration_categories/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a registration categories by ID.
     *
     * @tags registration_categories
     * @name RegistrationCategoriesDestroy
     * @summary Delete a registration categories
     * @request DELETE:/api/registration_categories/{id}
     * @secure
     */
    registrationCategoriesDestroy: (id: number, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/registration_categories/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Retrieve a list of registrations.
     *
     * @tags registrations
     * @name RegistrationsList
     * @summary List registrations
     * @request GET:/api/registrations
     * @secure
     */
    registrationsList: (
      query?: {
        age_category?: number;
        club?: number;
        competition?: number;
        competition_type?: number;
        division?: number;
        /** If true, only return registrations the current user can edit. */
        editable?: boolean;
        exclude_with_result?: boolean;
        id?: number;
        is_approved?: boolean;
        is_reserve?: boolean;
        /**
         * Order results by fields (comma separated). Prefix with `-` for descending order.
         *
         * Supported values: `id`, `competition_type`, `weight_class`, `age_category`,
         * `first_name`, `last_name`, `club_name`.
         */
        ordering?: string;
        /** A page number within the paginated result set. */
        page?: number;
        /** Number of results to return per page. */
        page_size?: number;
        person?: number;
        /** A search term. */
        search?: string;
        /** If true, include historical/deleted registration versions (federation admins only). Defaults to false. */
        show_history?: boolean;
        /**
         * * `APPROVED` - Approved
         * * `WITHDRAWN` - Withdrawn
         * * `NOT_APPROVED` - Not Approved
         */
        state?: "APPROVED" | "NOT_APPROVED" | "WITHDRAWN";
        team?: number;
        weight_class?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedRegistrationList, any>({
        path: `/api/registrations`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new registration.
     *
     * @tags registrations
     * @name RegistrationsCreate
     * @summary Create a registration
     * @request POST:/api/registrations
     * @secure
     */
    registrationsCreate: (
      data: RegistrationWriteRequest,
      params: RequestParams = {},
    ) =>
      this.request<Registration, any>({
        path: `/api/registrations`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve a registration by ID.
     *
     * @tags registrations
     * @name RegistrationsRetrieve
     * @summary Retrieve a registration
     * @request GET:/api/registrations/{id}
     * @secure
     */
    registrationsRetrieve: (id: number, params: RequestParams = {}) =>
      this.request<Registration, any>({
        path: `/api/registrations/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update a registration by ID.
     *
     * @tags registrations
     * @name RegistrationsUpdate
     * @summary Update a registration
     * @request PUT:/api/registrations/{id}
     * @secure
     */
    registrationsUpdate: (
      id: number,
      data: RegistrationWriteRequest,
      params: RequestParams = {},
    ) =>
      this.request<Registration, any>({
        path: `/api/registrations/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * @description Partially update a registration by ID.
     *
     * @tags registrations
     * @name RegistrationsPartialUpdate
     * @summary Partially update a registration
     * @request PATCH:/api/registrations/{id}
     * @secure
     */
    registrationsPartialUpdate: (
      id: number,
      data: PatchedRegistrationWriteRequest,
      params: RequestParams = {},
    ) =>
      this.request<Registration, any>({
        path: `/api/registrations/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a registration by ID.
     *
     * @tags registrations
     * @name RegistrationsDestroy
     * @summary Delete a registration
     * @request DELETE:/api/registrations/{id}
     * @secure
     */
    registrationsDestroy: (id: number, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/registrations/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags results
     * @name ResultsList
     * @request GET:/api/results
     * @secure
     */
    resultsList: (
      query?: {
        age_category?: number;
        bench?: number;
        body_weight?: number;
        competition?: number;
        /** Filter by one or more CompetitionType IDs. Use the competition types endpoint to discover valid IDs. */
        competition_type?: number[];
        deadlift?: number;
        /**
         * Controls whether this result should be included in or excluded from records
         *
         * * `default` - Default
         * * `exclude` - Exclude
         * * `include` - Include
         */
        district_record_status?: "default" | "exclude" | "include";
        division?: number;
        /** @format date */
        end_date?: string;
        group?: number;
        is_male?: boolean;
        license?: number;
        /**
         * Controls whether this result should be included in or excluded from records
         *
         * * `default` - Default
         * * `exclude` - Exclude
         * * `include` - Include
         */
        national_record_status?: "default" | "exclude" | "include";
        only_can_modify_record?: boolean;
        /** Which field to use when ordering the results. */
        ordering?: string;
        /** A page number within the paginated result set. */
        page?: number;
        /** Number of results to return per page. */
        page_size?: number;
        person?: number;
        /** A search term. */
        search?: string;
        squat?: number;
        /** @format date */
        start_date?: string;
        team?: number;
        total?: number;
        weight_class?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedResultList, any>({
        path: `/api/results`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags results
     * @name ResultsCreate
     * @request POST:/api/results
     * @secure
     */
    resultsCreate: (data: ResultWriteRequest, params: RequestParams = {}) =>
      this.request<ResultWrite, any>({
        path: `/api/results`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags results
     * @name ResultsRetrieve
     * @request GET:/api/results/{id}
     * @secure
     */
    resultsRetrieve: (id: number, params: RequestParams = {}) =>
      this.request<Result, any>({
        path: `/api/results/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags results
     * @name ResultsUpdate
     * @request PUT:/api/results/{id}
     * @secure
     */
    resultsUpdate: (
      id: number,
      data: ResultWriteRequest,
      params: RequestParams = {},
    ) =>
      this.request<ResultWrite, any>({
        path: `/api/results/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags results
     * @name ResultsPartialUpdate
     * @request PATCH:/api/results/{id}
     * @secure
     */
    resultsPartialUpdate: (
      id: number,
      data: PatchedResultWriteRequest,
      params: RequestParams = {},
    ) =>
      this.request<ResultWrite, any>({
        path: `/api/results/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags results
     * @name ResultsDestroy
     * @request DELETE:/api/results/{id}
     * @secure
     */
    resultsDestroy: (id: number, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/results/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Retrieve one best result per lifter. District and club combine using OR to define the ranking population; search preserves positions within that ranking.
     *
     * @tags results
     * @name ResultsRankingList
     * @request GET:/api/results/ranking
     * @secure
     */
    resultsRankingList: (
      query: {
        /** Age category IDs, passed as repeated parameters. Omit to include all categories for the competition type. With current_age_categories=true, matches lifter eligibility at end_date or today when end_date is omitted. */
        age_categories?: number[];
        /** Club IDs on the result license. Repeat the parameter to match any listed club. Applied before ranking and combined with district using OR. */
        club?: number[];
        /** ID of the competition type. */
        competition_type: number;
        /**
         * Evaluate age category eligibility at end_date, or today if omitted, instead of when the result was achieved. Earlier results from other age categories may qualify. Senior remains an overlapping category. Returned result categories and weight-class matching remain historical. Lifters with unknown birth dates are excluded. Search still preserves rank.
         * @default false
         */
        current_age_categories?: boolean;
        /**
         * Discipline for ranking. Unrecognized values fall back to total.
         *
         * * `sq` - sq
         * * `bp` - bp
         * * `dl` - dl
         * * `total` - total
         * * `points` - points
         * @minLength 1
         * @default "total"
         */
        discipline?: "sq" | "bp" | "dl" | "total" | "points";
        /** District IDs of the result license club. Repeat the parameter to match any listed district. Applied before ranking and combined with club using OR. */
        district?: number[];
        /**
         * End date for filtering results.
         * @format date
         */
        end_date?: string | null;
        /** Filter by gender using true or false. Omit to include both. */
        is_male?: boolean | null;
        /** A page number within the paginated result set. */
        page?: number;
        /** Number of results to return per page. */
        page_size?: number;
        /**
         * Point type for points ranking. If omitted, defaults to IPF GL, U11-13 for the sole U11-13 category, or Para for para bench press; bench variants use bench points. Unrecognized values fall back to IPF GL.
         *
         * * `ipfgl` - ipfgl
         * * `ipfglbp` - ipfglbp
         * * `dots` - dots
         * * `dotsbp` - dotsbp
         * * `wilks` - wilks
         * * `wilksbp` - wilksbp
         * * `ipf` - ipf
         * * `ipfbp` - ipfbp
         * * `u11_13` - u11_13
         * * `u11_13bp` - u11_13bp
         * * `para` - para
         * @minLength 1
         */
        point_type?:
          | "ipfgl"
          | "ipfglbp"
          | "dots"
          | "dotsbp"
          | "wilks"
          | "wilksbp"
          | "ipf"
          | "ipfbp"
          | "u11_13"
          | "u11_13bp"
          | "para"
          | null;
        /**
         * Case-insensitive partial search of lifter first/last name, club name, or district name on the selected best result. Every whitespace-separated word must match a field. Preserves rank_nr. Count and pages cover matches only.
         * @default ""
         */
        search?: string;
        /**
         * Start date for filtering results.
         * @format date
         */
        start_date?: string | null;
        /** Weight class IDs, passed as repeated parameters. Omit to include all weight classes for the competition type. */
        weight_classes?: number[];
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedResultRankingList, void>({
        path: `/api/results/ranking`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns a list of disciplines including total and points.
     *
     * @tags results
     * @name ResultsRankingDisciplineList
     * @summary Get list of disciplines
     * @request GET:/api/results/ranking_discipline
     * @secure
     */
    resultsRankingDisciplineList: (
      query?: {
        /** ID of the competition type to get disciplines for. */
        competition_type?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<RankingDisicipline[], any>({
        path: `/api/results/ranking_discipline`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve ranking based on competition type, age categories, weight classes, and discipline.
     *
     * @tags results
     * @name ResultsRecordsList
     * @request GET:/api/results/records
     * @secure
     */
    resultsRecordsList: (
      query: {
        /** ID of the age category. */
        age_category: number;
        /** List of IDs of the competition types. Use the competition types endpoint to discover valid IDs. */
        competition_types: number[];
        /** ID of the district. */
        district?: number;
        /** Filter by gender. */
        is_male?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<RecordCompetitionType[], void>({
        path: `/api/results/records`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve a list of round results.
     *
     * @tags round_results
     * @name RoundResultsList
     * @summary List round results
     * @request GET:/api/round_results
     * @secure
     */
    roundResultsList: (
      query?: {
        division?: number;
        id?: number;
        /** Which field to use when ordering the results. */
        ordering?: string;
        /** A page number within the paginated result set. */
        page?: number;
        /** Number of results to return per page. */
        page_size?: number;
        round?: number;
        series?: number;
        team?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedRoundResultList, any>({
        path: `/api/round_results`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new round result.
     *
     * @tags round_results
     * @name RoundResultsCreate
     * @summary Create a round result
     * @request POST:/api/round_results
     * @secure
     */
    roundResultsCreate: (
      data: RoundResultWriteRequest,
      params: RequestParams = {},
    ) =>
      this.request<RoundResult, any>({
        path: `/api/round_results`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve a round result by ID.
     *
     * @tags round_results
     * @name RoundResultsRetrieve
     * @summary Retrieve a round result
     * @request GET:/api/round_results/{id}
     * @secure
     */
    roundResultsRetrieve: (id: number, params: RequestParams = {}) =>
      this.request<RoundResult, any>({
        path: `/api/round_results/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update a round result by ID.
     *
     * @tags round_results
     * @name RoundResultsUpdate
     * @summary Update a round result
     * @request PUT:/api/round_results/{id}
     * @secure
     */
    roundResultsUpdate: (
      id: number,
      data: RoundResultWriteRequest,
      params: RequestParams = {},
    ) =>
      this.request<RoundResult, any>({
        path: `/api/round_results/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * @description Partially update a round result by ID.
     *
     * @tags round_results
     * @name RoundResultsPartialUpdate
     * @summary Partially update a round result
     * @request PATCH:/api/round_results/{id}
     * @secure
     */
    roundResultsPartialUpdate: (
      id: number,
      data: PatchedRoundResultWriteRequest,
      params: RequestParams = {},
    ) =>
      this.request<RoundResult, any>({
        path: `/api/round_results/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a round result by ID.
     *
     * @tags round_results
     * @name RoundResultsDestroy
     * @summary Delete a round result
     * @request DELETE:/api/round_results/{id}
     * @secure
     */
    roundResultsDestroy: (id: number, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/round_results/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Add a result, or multiple results, to a round result.
     *
     * @tags round_results
     * @name RoundResultsAddResultsCreate
     * @request POST:/api/round_results/{id}/add_results
     * @secure
     */
    roundResultsAddResultsCreate: (
      id: number,
      data: RoundResultModifyResultRequest,
      params: RequestParams = {},
    ) =>
      this.request<RoundResult, void>({
        path: `/api/round_results/${id}/add_results`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * @description Remove a result, or multiple results from a round result.
     *
     * @tags round_results
     * @name RoundResultsRemoveResultsCreate
     * @request POST:/api/round_results/{id}/remove_results
     * @secure
     */
    roundResultsRemoveResultsCreate: (
      id: number,
      data: RoundResultModifyResultRequest,
      params: RequestParams = {},
    ) =>
      this.request<RoundResult, void>({
        path: `/api/round_results/${id}/remove_results`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve eligible results for a given team and round.
     *
     * @tags round_results
     * @name RoundResultsEligibleResultsList
     * @request GET:/api/round_results/eligible_results
     * @secure
     */
    roundResultsEligibleResultsList: (
      query: {
        /** Round ID */
        round: number;
        /** Team ID */
        team: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<CompetitionResult[], void>({
        path: `/api/round_results/eligible_results`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags rounds
     * @name RoundsList
     * @request GET:/api/rounds
     * @secure
     */
    roundsList: (
      query?: {
        /** @format date */
        end?: string;
        id?: number;
        name?: string;
        /** Which field to use when ordering the results. */
        ordering?: string;
        /** A page number within the paginated result set. */
        page?: number;
        /** Number of results to return per page. */
        page_size?: number;
        /** A search term. */
        search?: string;
        /** @format date */
        start?: string;
        year?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedRoundList, any>({
        path: `/api/rounds`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags rounds
     * @name RoundsCreate
     * @request POST:/api/rounds
     * @secure
     */
    roundsCreate: (data: RoundRequest, params: RequestParams = {}) =>
      this.request<Round, any>({
        path: `/api/rounds`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags rounds
     * @name RoundsRetrieve
     * @request GET:/api/rounds/{id}
     * @secure
     */
    roundsRetrieve: (id: number, params: RequestParams = {}) =>
      this.request<Round, any>({
        path: `/api/rounds/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags rounds
     * @name RoundsUpdate
     * @request PUT:/api/rounds/{id}
     * @secure
     */
    roundsUpdate: (
      id: number,
      data: RoundRequest,
      params: RequestParams = {},
    ) =>
      this.request<Round, any>({
        path: `/api/rounds/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags rounds
     * @name RoundsPartialUpdate
     * @request PATCH:/api/rounds/{id}
     * @secure
     */
    roundsPartialUpdate: (
      id: number,
      data: PatchedRoundRequest,
      params: RequestParams = {},
    ) =>
      this.request<Round, any>({
        path: `/api/rounds/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags rounds
     * @name RoundsDestroy
     * @request DELETE:/api/rounds/{id}
     * @secure
     */
    roundsDestroy: (id: number, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/rounds/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Retrieve a list of series.
     *
     * @tags series
     * @name SeriesList
     * @summary List series
     * @request GET:/api/series
     * @secure
     */
    seriesList: (
      query?: {
        competition_type?: number;
        /**
         * * `M` - Herr
         * * `F` - Dam
         * * `B` - Blandat
         */
        gender?: "B" | "F" | "M";
        id?: number;
        /** Which field to use when ordering the results. */
        ordering?: string;
        /** A page number within the paginated result set. */
        page?: number;
        /** Number of results to return per page. */
        page_size?: number;
        /** A search term. */
        search?: string;
        year?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedSeriesList, any>({
        path: `/api/series`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new series.
     *
     * @tags series
     * @name SeriesCreate
     * @summary Create a series
     * @request POST:/api/series
     * @secure
     */
    seriesCreate: (data: SeriesWriteRequest, params: RequestParams = {}) =>
      this.request<Series, any>({
        path: `/api/series`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve a series by ID.
     *
     * @tags series
     * @name SeriesRetrieve
     * @summary Retrieve a series
     * @request GET:/api/series/{id}
     * @secure
     */
    seriesRetrieve: (id: number, params: RequestParams = {}) =>
      this.request<SeriesDetailed, any>({
        path: `/api/series/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update a series by ID.
     *
     * @tags series
     * @name SeriesUpdate
     * @summary Update a series
     * @request PUT:/api/series/{id}
     * @secure
     */
    seriesUpdate: (
      id: number,
      data: SeriesWriteRequest,
      params: RequestParams = {},
    ) =>
      this.request<Series, any>({
        path: `/api/series/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * @description Partially update a series by ID.
     *
     * @tags series
     * @name SeriesPartialUpdate
     * @summary Partially update a series
     * @request PATCH:/api/series/{id}
     * @secure
     */
    seriesPartialUpdate: (
      id: number,
      data: PatchedSeriesWriteRequest,
      params: RequestParams = {},
    ) =>
      this.request<Series, any>({
        path: `/api/series/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a series by ID.
     *
     * @tags series
     * @name SeriesDestroy
     * @summary Delete a series
     * @request DELETE:/api/series/{id}
     * @secure
     */
    seriesDestroy: (id: number, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/series/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Retrieve a list of years for which there is a series.
     *
     * @tags series
     * @name SeriesListYearsRetrieve
     * @summary List years with series
     * @request GET:/api/series/list_years
     * @secure
     */
    seriesListYearsRetrieve: (params: RequestParams = {}) =>
      this.request<YearListResponse, any>({
        path: `/api/series/list_years`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags standard_records
     * @name StandardRecordsList
     * @request GET:/api/standard_records
     * @secure
     */
    standardRecordsList: (
      query?: {
        age_category?: number;
        competition_type?: number;
        /**
         * * `sq` - Knäböj
         * * `bp` - Bänkpress
         * * `dl` - Marklyft
         * * `total` - Sammanlagt
         */
        discipline?: "bp" | "dl" | "sq" | "total";
        /** Filter by district, or national record if 0 */
        district?: number;
        id?: number;
        is_male?: boolean;
        /** Filter by latest record */
        latest?: boolean;
        weight_class?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<StandardRecord[], any>({
        path: `/api/standard_records`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags standard_records
     * @name StandardRecordsCreate
     * @request POST:/api/standard_records
     * @secure
     */
    standardRecordsCreate: (
      data: StandardRecordRequest,
      params: RequestParams = {},
    ) =>
      this.request<StandardRecord, any>({
        path: `/api/standard_records`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags standard_records
     * @name StandardRecordsRetrieve
     * @request GET:/api/standard_records/{id}
     * @secure
     */
    standardRecordsRetrieve: (id: number, params: RequestParams = {}) =>
      this.request<StandardRecord, any>({
        path: `/api/standard_records/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags standard_records
     * @name StandardRecordsUpdate
     * @request PUT:/api/standard_records/{id}
     * @secure
     */
    standardRecordsUpdate: (
      id: number,
      data: StandardRecordRequest,
      params: RequestParams = {},
    ) =>
      this.request<StandardRecord, any>({
        path: `/api/standard_records/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags standard_records
     * @name StandardRecordsPartialUpdate
     * @request PATCH:/api/standard_records/{id}
     * @secure
     */
    standardRecordsPartialUpdate: (
      id: number,
      data: PatchedStandardRecordRequest,
      params: RequestParams = {},
    ) =>
      this.request<StandardRecord, any>({
        path: `/api/standard_records/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags standard_records
     * @name StandardRecordsDestroy
     * @request DELETE:/api/standard_records/{id}
     * @secure
     */
    standardRecordsDestroy: (id: number, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/standard_records/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Returns a list of available record disciplines, optionally filtered by competition type.
     *
     * @tags standard_records
     * @name StandardRecordsRecordDisciplineList
     * @summary Get available record disciplines
     * @request GET:/api/standard_records/record_discipline
     * @secure
     */
    standardRecordsRecordDisciplineList: (
      query?: {
        /** Competition type ID to filter disciplines. If provided, disciplines will be filtered based on the competition type rules. */
        competition_type?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<StandardRecordDiscipline[], void>({
        path: `/api/standard_records/record_discipline`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags teams
     * @name TeamsList
     * @request GET:/api/teams
     * @secure
     */
    teamsList: (
      query?: {
        club?: number;
        division?: number;
        id?: number;
        name?: string;
        /** Which field to use when ordering the results. */
        ordering?: string;
        /** A page number within the paginated result set. */
        page?: number;
        /** Number of results to return per page. */
        page_size?: number;
        /** A search term. */
        search?: string;
        /** Filter by series */
        series?: number;
        /** Filter by year */
        year?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedTeamList, any>({
        path: `/api/teams`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags teams
     * @name TeamsCreate
     * @request POST:/api/teams
     * @secure
     */
    teamsCreate: (data: TeamWriteRequest, params: RequestParams = {}) =>
      this.request<TeamWrite, any>({
        path: `/api/teams`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags teams
     * @name TeamsRetrieve
     * @request GET:/api/teams/{id}
     * @secure
     */
    teamsRetrieve: (id: number, params: RequestParams = {}) =>
      this.request<TeamDetailed, any>({
        path: `/api/teams/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags teams
     * @name TeamsUpdate
     * @request PUT:/api/teams/{id}
     * @secure
     */
    teamsUpdate: (
      id: number,
      data: TeamWriteRequest,
      params: RequestParams = {},
    ) =>
      this.request<TeamWrite, any>({
        path: `/api/teams/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags teams
     * @name TeamsPartialUpdate
     * @request PATCH:/api/teams/{id}
     * @secure
     */
    teamsPartialUpdate: (
      id: number,
      data: PatchedTeamWriteRequest,
      params: RequestParams = {},
    ) =>
      this.request<TeamWrite, any>({
        path: `/api/teams/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags teams
     * @name TeamsDestroy
     * @request DELETE:/api/teams/{id}
     * @secure
     */
    teamsDestroy: (id: number, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/teams/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Retrieve a list of all users.
     *
     * @tags users
     * @name UsersList
     * @summary List all users
     * @request GET:/api/users
     * @secure
     */
    usersList: (params: RequestParams = {}) =>
      this.request<User[], any>({
        path: `/api/users`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new user.
     *
     * @tags users
     * @name UsersCreate
     * @summary Create a new user
     * @request POST:/api/users
     * @secure
     */
    usersCreate: (data: UserRequest, params: RequestParams = {}) =>
      this.request<User, any>({
        path: `/api/users`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve a user by ID.
     *
     * @tags users
     * @name UsersRetrieve
     * @summary Retrieve a user
     * @request GET:/api/users/{id}
     * @secure
     */
    usersRetrieve: (id: number, params: RequestParams = {}) =>
      this.request<User, any>({
        path: `/api/users/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update a user by ID.
     *
     * @tags users
     * @name UsersUpdate
     * @summary Update a user
     * @request PUT:/api/users/{id}
     * @secure
     */
    usersUpdate: (id: number, data: UserRequest, params: RequestParams = {}) =>
      this.request<User, any>({
        path: `/api/users/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * @description Partially update a user by ID.
     *
     * @tags users
     * @name UsersPartialUpdate
     * @summary Partially update a user
     * @request PATCH:/api/users/{id}
     * @secure
     */
    usersPartialUpdate: (
      id: number,
      data: PatchedUserRequest,
      params: RequestParams = {},
    ) =>
      this.request<User, any>({
        path: `/api/users/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a user by ID.
     *
     * @tags users
     * @name UsersDestroy
     * @summary Delete a user
     * @request DELETE:/api/users/{id}
     * @secure
     */
    usersDestroy: (id: number, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/users/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Make a user a federation admin by email.
     *
     * @tags users
     * @name UsersSetFederationAdminCreate
     * @request POST:/api/users/set_federation_admin
     * @secure
     */
    usersSetFederationAdminCreate: (
      data: MakeFederationAdminRequestRequest,
      params: RequestParams = {},
    ) =>
      this.request<MakeFederationAdminResponse, void>({
        path: `/api/users/set_federation_admin`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * @description Make a user a judge admin by email.
     *
     * @tags users
     * @name UsersSetJudgeAdminCreate
     * @request POST:/api/users/set_judge_admin
     * @secure
     */
    usersSetJudgeAdminCreate: (
      data: MakeJudgeAdminRequestRequest,
      params: RequestParams = {},
    ) =>
      this.request<MakeJudgeAdminResponse, void>({
        path: `/api/users/set_judge_admin`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve a list of weight classes.
     *
     * @tags weight_classes
     * @name WeightClassesList
     * @summary List weight classes
     * @request GET:/api/weight_classes
     * @secure
     */
    weightClassesList: (
      query?: {
        active?: boolean;
        age_category?: number;
        competition_type_name?: string;
        competition_types?: number[];
        /** @format date */
        date?: string;
        is_male?: boolean;
        max_weight?: number;
        min_weight?: number;
        /** Which field to use when ordering the results. */
        ordering?: string;
        person?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<WeightClass[], any>({
        path: `/api/weight_classes`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve a weight class by ID.
     *
     * @tags weight_classes
     * @name WeightClassesRetrieve
     * @summary Retrieve a weight class
     * @request GET:/api/weight_classes/{id}
     * @secure
     */
    weightClassesRetrieve: (id: number, params: RequestParams = {}) =>
      this.request<WeightClass, any>({
        path: `/api/weight_classes/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
